/* eslint-disable no-irregular-whitespace */
/* eslint-disable prettier/prettier */
/* eslint-disable no-useless-catch */
/* eslint-disable no-param-reassign */
// import axios, { AxiosRequestConfig } from 'axios';
import _, { update } from 'lodash';
import { FieldValues } from 'react-hook-form';
import { IWorkHistory } from '../pages/new-designs/components/WorkHistory';
import { getUserDetails } from '../utils/orgName';
import { getProgramContext } from '../hooks/useProgramContext';
import { withVersioningOffGuard } from '../utils/courseVersioningSession';
import axios, { type AxiosRequestConfig } from 'axios';
import { setupCache, type HeaderInterpreter } from 'axios-cache-interceptor';
import { Social } from '../pages/new-designs/components/SocialIcon';
import { ITaskData } from '../redux/slices/tasksSlice';
import type { GroupMemberAttributesPutItem } from '../pages/new-designs/utils/memberAttributes';
import type { LearnerWhatsNew } from '../components/course-versioning/learnerWhatsNew';
import type { AudienceRequirementsResponse, ProgramAudienceGroups } from './audienceRequirements';

// axios.interceptors.request.use((config) => {
//   // Generate a unique key based on URL, method, and relevant data parameters
//   const customKey = `${config.url}_${config.method}_${JSON.stringify(config.data)}`;
//   config.headers['X-Custom-Cache-Key'] = customKey;

//   return config;
// });

const axiosCached = setupCache(axios);

// Base URL for the program-collaborator endpoints (invites, edit lock, stored
// bell items) and the endpoints that change with them. Dev-only override:
// set REACT_APP_API_LOCAL in .env.development.local to send just these calls
// to a local BE while everything else stays on the cloud API. Unset anywhere
// else, so production is unaffected.
const collabApiBase = () => process.env.REACT_APP_API_LOCAL || process.env.REACT_APP_API;

const generateProgramStructure = ({
  generalPurpose,
  learningObjectives,
  groupId,
  orgDocsIds = [],
  programGenerationId,
  audience,
  tone,
  programPreview
}: {
  generalPurpose: string;
  learningObjectives: string[];
  groupId: string;
  orgDocsIds?: string[];
  programGenerationId: string;
  audience?: Array<{ attribute: string; value: string }>;
  tone?: string[];
  programPreview?: string;
}) => {
  const formData: Record<string, unknown> = {
    generalPurpose,
    learningObjectives,
    groupId,
    orgDocsIds
  };
  if (audience) formData.audience = audience;
  if (tone) formData.tone = tone;
  if (programPreview) formData.programPreview = programPreview;

  return axiosCached.post(`${process.env.REACT_APP_API}/program-generation/${programGenerationId}/generate-structure`, formData, {
    cache: false
  });
};

interface Lesson {
  title: string;
  // The Capability build flow: what the lesson is for (the backend keeps stored tags for a lesson sent without).
  capabilityId?: string;
  outcomes?: string[];
}

interface Module {
  title: string;
  lessons: Lesson[];
}

export interface OrgDocument {
  _id: string;
  fileName: string;
  title: string;
  createdAt: number;
  documentProcessingStatus: 'indexed' | 'processing' | 'failed'; // adicione outros status se existirem
  type: 'file' | 'webpage' | 'text';
  fileType?: string;
  fileSize?: number;
  uploadedUserId: string;
  // 'program' marks a doc auto-created when a program is published/indexed for
  // RAG, so the FE can show a COURSE badge instead of a generic TEXT one.
  source?: 'program' | string;
  /** Admin guidance for retrieving from this doc; carried over when the doc is replaced. */
  instruction?: string | null;
}

export interface GetOrgDocsResponse {
  documents: OrgDocument[];
  totalCount: number;
  orgId: string;
}

const getOrganizationDocuments = async (groupId: string): Promise<GetOrgDocsResponse> => {
  return axiosCached.get(`${process.env.REACT_APP_API}/orgDocs`, {
    cache: false, // 👈 Desativa o cache do axiosCached
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      groupId
    },
    params: {
      t: Date.now() // 👈 Evita cache do navegador ou intermediários
    }
  }).then(res => res.data);
};

const processDocument = (file: File, groupId: string, instruction?: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('isPublic', 'true');
  if (instruction) {
    formData.append('instruction', instruction);
  }

  return axios.post(`${process.env.REACT_APP_API}/process-document/async`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      groupid: groupId
    },
  });
};

const generateProgramContent = ({
  generalPurpose,
  learningObjectives,
  modules,
  orgDocsIds,
  programGenerationId,
  audience,
  tone,
  programPreview
}: {
  generalPurpose: string;
  learningObjectives: string[];
  modules: Module[];
  orgDocsIds: string[];
  programGenerationId: string;
  audience?: Array<{ attribute: string; value: string }>;
  tone?: string[];
  programPreview?: string;
}) => {
  const formData: Record<string, unknown> = {
    generalPurpose,
    learningObjectives,
    modules,
    orgDocsIds
  };
  if (audience) formData.audience = audience;
  if (tone) formData.tone = tone;
  if (programPreview) formData.programPreview = programPreview;

  return axiosCached.post(`${process.env.REACT_APP_API}/program-generation/${programGenerationId}/generate-content`, formData, {
    cache: false
  });
};

// When `existingGroupId` is provided the BE attaches the generation
// record to that program instead of spawning a fresh "AIMD-{ts}" group.
// Used by the LL Continue path so the existing program ends up updated
// rather than duplicated.
const generateProgramId = (existingGroupId?: string) => {
  const body = existingGroupId ? { existingGroupId } : {};
  return axiosCached.post(`${process.env.REACT_APP_API}/program-generation/create`, body, {
    cache: false
  });
};

const resumeProgramId = ({
  generationId,
}: {
  generationId: string;
}) => {

  const url = `${process.env.REACT_APP_API}/program-generation/${generationId}/resume`;

  return axiosCached.put(url, { cache: false });
};

const getProgramContent = ({
  generationId,
}: {
  generationId: string;
}) => {

  const url = `${process.env.REACT_APP_API}/program-generation/${generationId}/status`;

  return axiosCached.get(url, { cache: false });
};

const generateLessonImage = ({
  programGenerationId,
  lessonId,
  prompt,
  lessonContent,
  programName,
  programContext,
}: {
  programGenerationId: string;
  lessonId: string;
  prompt: string;
  lessonContent?: string;
  programName?: string;
  programContext?: string;
}) => {
  return axiosCached.post(
    `${collabApiBase()}/program-generation/${programGenerationId}/generate-image`,
    { lessonId, prompt, lessonContent, programName, programContext },
    { cache: false },
  );
};

const generateLessonVideo = ({
  programGenerationId,
  lessonId,
  prompt,
  lessonContent,
  programName,
  programContext,
}: {
  programGenerationId: string;
  lessonId: string;
  prompt: string;
  lessonContent?: string;
  programName?: string;
  programContext?: string;
}) => {
  return axiosCached.post(
    `${collabApiBase()}/program-generation/${programGenerationId}/generate-video`,
    { lessonId, prompt, lessonContent, programName, programContext },
    { cache: false },
  );
};

const getLessonVideoStatus = ({
  programGenerationId,
  videoJobId,
}: {
  programGenerationId: string;
  videoJobId: string;
}) => {
  // Polled on a timer: see `vbPoll` for why these carry a timeout.
  return axiosCached.get(
    `${collabApiBase()}/program-generation/${programGenerationId}/video-status/${videoJobId}`,
    { cache: false, timeout: 20000 },
  );
};

const getAllArticle = ({
  orgId,
  groupId,
  helpSettings,
  useCache,
  role,
  location
}: {
  orgId: string;
  groupId: string;
  helpSettings: boolean;
  useCache?: boolean;
  role?: string;
  location?: string;
}) => {
  const param = role ? `&role=${role}` : '';

  const url = `${process.env.REACT_APP_API}/group/${groupId}/getArticleList?helpSettings=${helpSettings}${param}`;

  const cacheOptions = useCache
    ? {
        ttl: 1000 * 60 * 5
      }
    : false;

  return axiosCached.get(url, {
    headers: {
      orgId: orgId,
      ...(location ? { location } : {})
    },
    cache: cacheOptions
  });
};

const updateBioData = ({ orgId, data }: { orgId: string; data: any }) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/updateBio`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.patch(`${process.env.REACT_APP_API}/updateBio`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getTagsListnew = (
  orgId: string,
  location: string,
  type?: string | undefined,
  value?: string | undefined,
  isFullList?: boolean
) => {
  if (typeof isFullList === 'undefined') {
    isFullList = false;
  }
  if (typeof type === 'undefined') {
    type = '';
  }
  if (typeof value === 'undefined') {
    value = '';
  }

  // const url = `${process.env.REACT_APP_API}/getTagsList?type=${type}&value=${value}&isFullList=${isFullList}`;

  // return axios({
  //   method: 'get',

  //   url: `${process.env.REACT_APP_API}/getTagsList?type=${type}&value=${value}&isFullList=${isFullList}`,
  //   headers: {
  //     orgId: orgId,

  //     location: location
  //   }
  // });

  return axiosCached.get(
    `${process.env.REACT_APP_API}/getTagsList?type=${type}&value=${value}&isFullList=${isFullList}`,
    {
      headers: {
        orgId: orgId,
        location: location
      },
      cache: {
        ttl: 1000 * 30
      }
    }
  );
};

const getAllTopicsForUser = (location: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/getAllTopicsForUser`, {
    headers: { location },
    cache: { ttl: 1000 * 60 * 15 }
  });
};

const getCommunityGroupsUsersListNew = (
  orgId: string,
  location: string,
  role?: string[],
  category?: string[],
  industry?: string[],
  hobbiesAndInterest?: string[],
  roleType?: string[]
  // useCache?:boolean
) => {
  // console.log('getCommunityGroupsUsersListNew called')
  let url = `${process.env.REACT_APP_API}/getCommunityGroupsUsersListNew`;

  if (role && role?.length > 0) {
    url += `?role=${role}`;
  }

  if (category && category?.length > 0) {
    if (role && role?.length > 0) {
      url += `&category=${category}`;
    } else {
      url += `?category=${category}`;
    }
  }

  if (hobbiesAndInterest && hobbiesAndInterest?.length > 0) {
    if (
      url.includes('role') ||
      url.includes('category') ||
      url.includes('industry') ||
      url.includes('roleType') ||
      url.includes('hobbiesAndInterest')
    ) {
      url += `&hobbiesAndInterest=${hobbiesAndInterest}`;
    } else {
      url += `?hobbiesAndInterest=${hobbiesAndInterest}`;
    }
  }

  if (industry && industry?.length > 0) {
    if (
      url.includes('role') ||
      url.includes('category') ||
      url.includes('hobbiesAndInterest') ||
      url.includes('roleType') ||
      url.includes('industry')
    ) {
      url += `&industry=${industry}`;
    } else {
      url += `?industry=${industry}`;
    }
  }

  if (roleType && roleType?.length > 0) {
    if (
      url.includes('role') ||
      url.includes('category') ||
      url.includes('industry') ||
      url.includes('hobbiesAndInterest') ||
      url.includes('roleType')
    ) {
      url += `&roleType=${roleType}`;
    } else {
      url += `?roleType=${roleType}`;
    }
  }

  // return axios({
  //   method: 'post',
  //   url: url,
  //   headers: {
  //     orgId: orgId,
  //     location: location
  //   }
  // });

  // const cacheOptions = useCache ? {
  //   ttl: 1000 * 60 * 15 // cache for 5 minutes
  // } : false; // bypass cache

  return axiosCached.post(
    url,
    {
      orgId: orgId,
      location: location
    },
    {
      cache: {
        methods: ['post'],
        ttl: 1000 * 60 * 15 // Setting ttl to 0 to disable caching
      }
      // cache: {ttl: 1000 * 60 * 15}ttl: 1000 * 60 * 15
    }
  );
};

const getCommunityGroupsUsersListNewDuplicate = ({ orgId, location }: { orgId: string; location: string }) => {
  let url = `${process.env.REACT_APP_API}/getCommunityGroupsUsersListNew`;

  return axiosCached.post(
    url,
    {
      orgId: orgId,
      location: location
    },
    {
      cache: false
    }
  );
};

const getAllArticleUser = ({
  orgId,
  tags,
  type,
  industries,
  helpSettings,
  useCache, // Add this parameter to control caching
  location,
  includeUnpublished
}: {
  orgId: string;
  tags?: string[];
  type?: string[];
  industries?: string[];
  helpSettings: boolean;
  useCache?: boolean; // Add this to the parameter type definition
  location?: string;
  /** The admin Resources page: the org's unpublished resources too (org admins only, BE side). */
  includeUnpublished?: boolean;
}) => {
  let url = `${process.env.REACT_APP_API}/getLibraryArticlesList?helpSettings=${helpSettings}`;
  if (includeUnpublished) url += '&includeUnpublished=true';
  // Construct the URL with query parameters
  if (industries && industries.length > 0) {
    url += `&industries=${encodeURIComponent(industries.join(','))}`;
  }
  if (tags && tags.length > 0) {
    url += `&tags=${encodeURIComponent(tags.join(','))}`;
  }
  if (type && type.length > 0) {
    url += `&type=${encodeURIComponent(type.join(','))}`;
  }

  // Set cache options based on useCache parameter
  const cacheOptions = useCache
    ? {
        ttl: 1000 * 60 * 5 // cache for 5 minutes
      }
    : false; // bypass cache

  return axiosCached.get(url, {
    headers: {
      orgId: orgId,
      // Forward the region so EU/other-region orgs query the right database.
      // Without this the backend defaults to 'us' and returns no resources.
      ...(location ? { location } : {})
    },
    // Honour useCache so a fresh fetch (e.g. right after creating a resource) is
    // not served a stale 5-minute cached list.
    cache: cacheOptions
  });
};

const getOrganizations = (token: string, currentPageNumber: number, perPage: number) => {
  // return axios({
  //   method: 'get',
  //   // url: `${process.env.REACT_APP_API}/organizationsListGet?page=${currentPageNumber}&per_page=${perPage}`,
  //   url: `${process.env.REACT_APP_API}/organizationsListGet?page=0&per_page=100`,
  //   headers: {
  //     authorization: `Bearer ${token}`
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/organizationsListGet?page=0&per_page=100`, {
    headers: {
      authorization: `Bearer ${token}`
    },
    cache: false
  });
};

const updateHobbies = ({
  orgId,
  data,
  idtoken,
  token
}: {
  orgId: string;
  idtoken: string;
  token: string;
  data: string[];
}) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/createHobies`,
  //   headers: {
  //     orgId: orgId,
  //     idtoken: idtoken,
  //     token: token
  //   },
  //   data: { hobbies: data }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/createHobies`,
    {
      hobbies: data
    },
    {
      headers: {
        orgId: orgId,
        idtoken: idtoken,
        token: token
      },
      cache: false
    }
  );
};

const getTagsList = (orgId: string, location: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getTagsList?type=Hobbies and Interests&isFullList=true`,
  //   headers: {
  //     orgId: orgId,
  //     location: location
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getTagsList`, {
    params: {
      type: 'Hobbies and Interests',
      isFullList: true
    },
    headers: {
      orgId: orgId,
      location: location
    },
    cache: {
      ttl: 1000 * 60 * 15
    }
  });
};

const getCommunityMembers = (orgId: string, location: string, role?: string, category?: string) => {
  let url = `${process.env.REACT_APP_API}/getCommunityGroupsUsersList`;

  if (role) {
    url += `?role=${role}`;
  }

  if (category) {
    if (role) {
      url += `&category=${category}`;
    } else {
      url += `?category=${category}`;
    }
  }

  return axios({
    method: 'POST',
    url: url,
    headers: {
      orgId: orgId,
      location: location
    }
  });
};

const removeOrganization = (token: string, orgId: string, dataLocation: string) => {
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/organizationDelete/${orgId}`,
    headers: {
      authorization: `Bearer ${token}`,
      location: dataLocation
    }
  });
};

const getUsersMetaByOrgId = (token: string, orgId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getUsersWithMetadata/${orgId}`,
  //   headers: {
  //     orgId: orgId,
  //     authorization: `Bearer ${token}`
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getUsersWithMetadata/${orgId}`, {
    headers: {
      orgId: orgId,
      authorization: `Bearer ${token}`
    },
    cache: {
      ttl: 0 // Setting ttl to 0 to bypass caching
    }
  });
};

const getUsersByOrgId = (token: string, orgId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getUsersByOrg/${orgId}`,

  //   headers: {
  //     authorization: `Bearer ${token}`,
  //     orgId: orgId !== '' ? orgId : null
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getUsersByOrg/${orgId}`, {
    headers: {
      authorization: `Bearer ${token}`,
      orgId: orgId !== '' ? orgId : null
    },
    cache: {
      ttl: 0 // Setting ttl to 0 to bypass caching
    }
  });
};

// const getMentorTask = ({ id }: { id: string }) => {
//   return axios({
//     method: 'get',
//     url: `${process.env.REACT_APP_API}/mentorTasks?id=${id}`
//   });
// };

const getMentorTask = ({ id }: { id?: any }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/mentorTasks?id=${id}`, {
    cache: {
      ttl: 0 // Set TTL to 0 for no caching
    }
  });
};

const saveMentorAnswers = ({
  groupId,
  levelId,
  taskId,
  ans
}: {
  groupId: any;
  levelId: any;
  taskId: any;
  ans: any;
}) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/task/${taskId}/answers`,
  //   data: {
  //     ans
  //   }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/task/${taskId}/answers`,
    {
      ans
    },
    {
      cache: {
        ttl: 0 // Setting ttl to 0 to bypass caching
      }
    }
  );
};

const saveMentorMultiAnswers = ({ groupId, tasks }: { groupId: any; tasks: any }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${groupId}/multiAnswers`,
  //   data: {
  //     tasks: tasks
  //   }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/group/${groupId}/multiAnswers`,
    {
      tasks
    },
    {
      cache: {
        ttl: 0 // Setting ttl to 0 to bypass caching
      }
    }
  );
};

const getUserDetailsById = (id: string) => {
  // return axios({
  //   method: 'GET',
  //   url: `${process.env.REACT_APP_API}/getUserDetailsById/${id}`,
  //   headers: {
  //     location: getUserDetails().location
  //     // idtoken:idtoken,
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getUserDetailsById/${id}`, {
    cache: false
  });
};

const getUserMetadData = (token: string, orgId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/createUserMetadata`,
  //   headers: {
  //     authorization: `Bearer ${token}`,
  //     orgId: orgId !== '' ? orgId : null
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/createUserMetadata`, {
    headers: {
      authorization: `Bearer ${token}`,
      orgId: orgId !== '' ? orgId : null
    },
    cache: false // Disabling caching for this specific request
  });
};

const updateUserFtue = ({ ftue, userId }: { ftue: boolean; userId: string }) => {
  const body = {
    ftue
  };
  // return axios({
  //   method: 'put',
  //   url: `${process.env.REACT_APP_API}/${userId}/ftue`,
  //   data: body
  // });

  return axiosCached.put(`${process.env.REACT_APP_API}/${userId}/ftue`, body, { cache: false });
};

const getOrgName = (orgId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/organizationGetById/${orgId}`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/organizationGetById/${orgId}`, {
    cache: false
    // cache: { ttl: 1000 * 60 * 5 }
  });
};

const addOrganization = (token: string, data: any) => {
  const data2 = {
    display_name: data.name,
    // oid: data.orgId,
    location: data.dataLocation
  };
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/organizationCreate`,
  //   headers: {
  //     authorization: `Bearer ${token}`,
  //     location: data.dataLocation
  //   },
  //   data: data2
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/organizationCreate`, data2, {
    headers: {
      authorization: `Bearer ${token}`,
      location: data.dataLocation
    },
    cache: false
  });
};

// eslint-disable-next-line no-undef
const updateOrganization = (token: string, orgId: string, data: IOrgSubmitValues) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/organizationUpdate/${orgId}`,
  //   headers: {
  //     authorization: `Bearer ${token}`
  //   },
  //   data: data
  // });

  return axiosCached.patch(`${process.env.REACT_APP_API}/organizationUpdate/${orgId}`, data, {
    headers: {
      authorization: `Bearer ${token}`
    },
    cache: false
  });
};

// eslint-disable-next-line no-undef
const inviteOrgAdmin = (token: string, orgId: string, data: IInviteOrgAdmin) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/inviteOrgAdmin/${orgId}`,
  //   headers: {
  //     authorization: `Bearer ${token}`
  //   },
  //   data: data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/inviteOrgAdmin/${orgId}`, data, {
    headers: {
      authorization: `Bearer ${token}`
    },
    cache: false
  });
};

// eslint-disable-next-line no-undef
const inviteMember = (token: string, orgId: string, data: IInviteOrgAdmin) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/inviteMembers/${orgId}`,
  //   headers: {
  //     authorization: `Bearer ${token}`
  //   },
  //   data: data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/inviteMembers/${orgId}`, data, {
    headers: {
      authorization: `Bearer ${token}`
    },
    cache: false
  });
};
const getOrgId = (orgName: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/organization/${orgName}`,
  //   headers: {}
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/organization/${orgName}`, {
    headers: {},
    cache: false
  });
};

// eslint-disable-next-line no-undef
const inviteApi = (token: string, orgId: string, data: IInviteOrgAdmin) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/invitations/${orgId}`,
  //   headers: {
  //     authorization: `Bearer ${token}`,
  //     orgId: orgId
  //   },
  //   data: data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/invitations/${orgId}`, data, {
    headers: {
      authorization: `Bearer ${token}`,
      orgId: orgId
    },
    cache: false
  });
};

// const getMemberRoles = (token:string, orgId: string, userId:string)=>{
//   return axios({
//     method:'GET',
//     url:`${process.env.REACT_APP_API}/getOrgMemRoles/${orgId}/${userId}`,
//     headers:{
//       authorization:`Bearer ${token}`
//     }
//   })
// }

const getMemberRoles = (token: string, orgId: string, userId: string) => {
  let url = `${process.env.REACT_APP_API}/user-role`;
  // return axios({
  //   method: 'GET',
  //   url,
  //   headers: {
  //     authorization: `Bearer ${token}`,
  //     orgId: orgId ? orgId : null
  //   }
  // });

  return axiosCached.get(url, {
    headers: {
      authorization: `Bearer ${token}`,
      orgId: orgId ? orgId : null
    },
    cache: false
  });
};

const getACSToken = ({ communicationId, tag }: { communicationId: string; tag: string }) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/azureToken`,
  //   data: {
  //     communicationId: communicationId,
  //     tag
  //   }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/azureToken`,
    {
      communicationId: communicationId,
      tag
    },
    {
      cache: false
    }
  );
};

const getACSThreads = (acsToken: string, orgId: string) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/getChatThread`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data: {
  //     azureToken: acsToken
  //   }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/getChatThread`,
    {
      azureToken: acsToken
    },
    {
      headers: {
        orgId: orgId
      },
      cache: false
    }
  );
};

const deleteACSThread = (acsToken: string, threadId: string, orgId: string) => {
  // return axios({
  //   method: 'DELETE',
  //   url: `${process.env.REACT_APP_API}/deleteChatThread`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data: {
  //     threadId: threadId,
  //     azureToken: acsToken
  //   }
  // });

  return axiosCached.delete(`${process.env.REACT_APP_API}/deleteChatThread`, {
    headers: {
      orgId: orgId
    },
    data: {
      threadId: threadId,
      azureToken: acsToken
    },
    cache: {
      ttl: 0
    }
  });
};

const deleteMsgCount = ({ threadId }: { threadId: any }) => {
  return axiosCached.delete(`${process.env.REACT_APP_API}/deleteThreadMsgCount?threadId=${threadId}`);
};

// const getACSOrgUsers = (orgId: string) => {
//   return axios({
//     method: "GET",
//     url: `${process.env.REACT_APP_API}/ACSusers/${orgId}`,
//     headers: {
//       orgId: orgId,
//     },
//   });
// };

const getACSOrgUsers = (
  orgId: string
  // location: string,
) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/getCommunityGroupsUsersList`,
  //   headers: {
  //     orgId: orgId,
  //     location: getUserDetails().location
  //   }
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/getCommunityGroupsUsersList`, null, {
    headers: {
      orgId: orgId
    },
    cache: {
      ttl: 0
    }
  });
};

const createACSThread = (acsToken: string, data: any, orgId: string) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/createChatThread`,
  //   // headers: {
  //   //   orgid: orgId,
  //   // },
  //   data
  //   // data: {
  //   //   ...data,
  //   //   participants: [
  //   //     { id: data?.participants[0]?.id, displayName: data?.participants[0]?.id?.communicationUserId},
  //   //   ],
  //   //   azureToken: acsToken,
  //   // },
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/createChatThread`, data, {
    // Uncomment the following lines if you need to include additional headers
    // headers: {
    //   orgid: orgId,
    // },
    cache: {
      ttl: 0
    }
  });
};

const getACSThreadParticipants = (acsToken: string, threadId: string) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/getParticipantsFromThreads`,
  //   data: {
  //     threadId: threadId,
  //     azureToken: acsToken
  //   }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/getParticipantsFromThreads`,
    {
      threadId: threadId,
      azureToken: acsToken
    },
    {
      cache: false
    }
  );
};

const sendMessageToACSThread = (
  acsToken: string,
  threadId: string,
  message: string,
  file: any,
  contentId: any,
  topic: string,
  displayNames: any
) => {
  const formData = new FormData();
  formData.append('threadId', threadId);
  formData.append('message', message);
  formData.append('file', file); // Assuming 'file' is a File object
  formData.append('contentId', contentId.toString());
  formData.append('azureToken', acsToken);
  formData.append('topic', topic);
  formData.append('displayNames', displayNames);
  formData.append('sentFrom', 'web');
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/sendMessages`,
  //   data: formData,
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   }
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/sendMessages`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    cache: false
  });
};

const readMessagesFromThreads = ({
  orgId,
  threadId,
  acsToken,
  idtoken
}: {
  orgId: string;
  threadId: string;
  acsToken: string;
  idtoken: string;
}) => {
  // return axios({
  //   method: 'GET',
  //   url: `${process.env.REACT_APP_API}/receiveMessages?azureToken=${acsToken}&threadId=${threadId}&pageSize=50&pageNumber=4`,
  //   headers: {
  //     orgId: orgId,
  //     idtoken: idtoken
  //   }
  // }).then((res) => {
  //   return _.reverse(_.get(res, 'data.recieved Messages', []));
  // });

  return axiosCached
    .get(`${process.env.REACT_APP_API}/receiveMessages`, {
      params: {
        azureToken: acsToken,
        threadId: threadId,
        pageSize: 50,
        pageNumber: 4
      },
      headers: {
        orgId: orgId,
        idtoken: idtoken
      },
      cache: false
    })
    .then((res) => {
      return _.reverse(_.get(res, 'data.recieved Messages', []));
    });
};

// const readMessagesFromThreadsByNextLink = ({ link, azureToken }: { link: string; azureToken: string }) => {
//   return fetch(`${link}`, {
//     headers: { authorization: `Bearer ${azureToken}` }
//   }).then((res) => res.json());
// };

// const readMessagesFromThreadsByNextLink = ({ link }: { link: string}) => {
//   return fetch(`${link}`).then((res) => res.json());
// };

const readMessagesFromThreadsByNextLink = ({ link }: { link: string }) => {
  // return axios.get(link).then((res) => res.data);

  return axiosCached
    .get(link, {
      cache: false
    })
    .then((res) => res.data);
};

const readMessagesFromThreadsByPage = ({
  threadId,
  acsToken,
  pageSize,
  pageNumber
}: {
  threadId: string;
  acsToken: string;
  pageSize: string;
  pageNumber: string;
}) => {
  // return axios({
  //   method: 'GET',
  //   url: `${process.env.REACT_APP_API}/receiveMessages?azureToken=${acsToken}&threadId=${threadId}&pageSize=${pageSize}&pageNumber=${pageNumber}`
  // }).then((res) => {
  //   return _.reverse(_.get(res, 'data.recieved Messages', []));
  // });

  return axiosCached
    .get(`${process.env.REACT_APP_API}/receiveMessages`, {
      params: {
        azureToken: acsToken,
        threadId: threadId,
        pageSize: pageSize,
        pageNumber: pageNumber
      },
      cache: false
    })
    .then((res) => {
      return _.reverse(_.get(res, 'data.recieved Messages', []));
    });
};

const addParticipantsToExistingChannel = ({ idtoken, orgId, data }: { idtoken: string; orgId: string; data: any }) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/addParticipants`,
  //   headers: {
  //     orgId: orgId,
  //     idtoken: idtoken
  //   },
  //   data: data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/addParticipants`, data, {
    headers: {
      orgId: orgId,
      idtoken: idtoken
    },
    cache: false
  });
};

const updateGroupChatName = ({
  orgId,
  acsToken,
  topic,
  threadId
}: {
  orgId: string;
  acsToken: string;
  topic: string;
  threadId: string;
}) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/renameGroupChat`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data: {
  //     azureToken: acsToken,
  //     topic,
  //     threadId
  //   }
  // });

  return axiosCached.patch(
    `${process.env.REACT_APP_API}/renameGroupChat`,
    {
      azureToken: acsToken,
      topic,
      threadId
    },
    {
      headers: {
        orgId: orgId
      },
      cache: false
    }
  );
};

export const uploadGroupChatPic = async ({
  orgId,
  tokens,
  values,
  threadId
}: {
  orgId: string;
  tokens: {
    access_token: string;
    id_token: string;
  };
  values: {
    image: File[];
  };
  threadId: string;
}) => {
  const url = `${process.env.REACT_APP_API}/groupChatPicUpload`;
  const formData = new FormData();
  formData.append('image', values.image[0]);
  formData.append('threadId', threadId);
  const headers = {
    orgId: orgId,
    Authorization: `Bearer ${tokens.access_token}`,
    idtoken: tokens.id_token
  };
  // const response = await axios.post(url, formData, { headers });
  const response = await axiosCached.post(url, formData, { headers, cache: false });

  return response.data;
};

// const removeParticipantFromThread = ({
//   orgId,
//   acsToken,
//   commId,
//   threadId,
// }: {
//   orgId: string;
//   acsToken: string;
//   commId: string;
//   threadId: string;
// }) => {
//   return axios({
//     method: "delete",
//     url: `${process.env.REACT_APP_API}/removeParticipantsFromThreads`,
//     headers: {
//       orgId: orgId,
//     },
//     data: {
//       azureToken: acsToken,
//       threadId,
//     },
//   });
// };
const removeParticipantFromThread = ({
  acsToken,
  threadId,
  communicationId,
  tag
}: {
  acsToken: string;
  communicationId: string;
  threadId: string;
  tag: string;
}) => {
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/removeParticipantsFromThreads`,

    data: {
      azureToken: acsToken,
      threadId,
      communicationId,
      tag
    }
  });
};

const editMessage = ({
  orgId,
  acsToken,
  messageId,
  content,
  file,
  threadId
}: {
  orgId: string;
  content: string;
  file: string;
  acsToken: string;
  messageId: string;
  threadId: string;
}) => {
  const formData = new FormData();
  formData.append('threadId', threadId);
  formData.append('messageId', messageId);
  formData.append('file', file);
  formData.append('content', content.toString());
  formData.append('azureToken', acsToken);
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/updateChatMessage`,
  //   data: formData,
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   }
  // });
  return axiosCached.patch(`${process.env.REACT_APP_API}/updateChatMessage`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    cache: false
  });
};

const deleteMessage = ({
  orgId,
  acsToken,
  messageId,
  threadId,
  tag
}: {
  orgId: string;
  acsToken: string;
  messageId: string;
  threadId: string;
  tag: string;
}) => {
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/deleteChatMessage`,
    headers: {
      orgId: orgId
    },
    data: {
      azureToken: acsToken,
      messageId,
      threadId,
      tag
    }
  });
};

const getACSChatThreads = ({
  acsToken,
  orgId,
  tag,
  communicationId
}: {
  acsToken: string;
  orgId: string;
  tag: string;
  communicationId: string;
}) => {
  const requestData = {
    tag,
    communicationId
  };
  // return axios({
  //   method: 'GET',
  //   url: `${process.env.REACT_APP_API}/getChatThread?azureToken=${acsToken}`,

  //   headers: {
  //     orgId: orgId,

  //   },
  //   params: requestData,
  // }).then((res) => res?.data);

  // const requestData = {
  //   tag,
  //   communicationId
  // };

  return axiosCached
    .get(`${process.env.REACT_APP_API}/getChatThread`, {
      params: {
        azureToken: acsToken,
        ...requestData
      },
      headers: {
        orgId: orgId
      },
      cache: false
    })
    .then((res) => res?.data);
};

const createUserProfile = ({ data, orgId }: { data: FormData; orgId: string }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/createUserProfile`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/createUserProfile`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

// Org-wide resource (orgLevelAdmin): create a resource not tied to any program.
const createOrgArticle = ({
  data,
  authId,
  location
}: {
  data: FormData;
  authId: string;
  location?: string;
}) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/org/${authId}/resources`, data, {
    headers: {
      orgId: authId,
      ...(location ? { location } : {})
    },
    cache: false
  });
};

const createArticle = ({
  data,
  orgId,
  groupId,
  helpSettings,
  location
}: {
  data: FormData;
  orgId: string;
  groupId: string;
  helpSettings: boolean;
  location?: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/group/${groupId}/createArticle?helpSettings=${helpSettings}`,
    data,
    {
      headers: {
        orgId: orgId,
        ...(location ? { location } : {})
      },
      cache: false
    }
  );
};

// const getAllArticle = ({ orgId, groupId, helpSettings }: { orgId: string; groupId: string; helpSettings: boolean }) => {
// const url = `${process.env.REACT_APP_API}/group/${groupId}/getArticleList?helpSettings=${helpSettings}`;
// return axios({
//   method: 'get',
//   url: `${process.env.REACT_APP_API}/group/${groupId}/getArticleList?helpSettings=${helpSettings}`,
//   headers: {
//     orgId: orgId
//   }
// });

//   return axiosCached.post(
//     url,
//     {
//         orgId,
//         // location
//         // Add other headers if needed
//     },{
//       cache: {
//         ttl: 1000 * 60 * 15,
//         interpretHeader: false,
//         methods: ['post']
//       },
//       statusCheck: (status: any) =>
//           [200, 203, 300, 301, 302, 404, 405, 410, 414, 501, 500, 502, 503].includes(status)

//       } as any
//     // }

//   );
// };

const getAllArticleById = ({
  orgId,
  articleId,
  groupId,
  isContentSettings,
  articleLocation,
  useCache
}: {
  orgId: string;
  articleId: string;
  groupId?: string;
  isContentSettings: boolean;
  articleLocation: any;
  useCache?: boolean;
}) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getArticleById/${articleId}?isContentSettings=${isContentSettings}`,
  //   headers: {
  //     orgId: orgId,
  //     location: 'us'
  //   }
  // });

  // const url = `${process.env.REACT_APP_API}/getArticleById/${articleId}?isContentSettings=${isContentSettings}`;

  // return axiosCached.get(
  //   url,
  //   {
  //     headers: {
  //       location: getUserDetails().location,
  //       orgId: orgId,
  //     },
  //     cache: {
  //       ttl: 1000 * 60 * 5, // Set TTL to 0 for no caching
  //     }
  //   },
  // )

  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getArticleById/${articleId}?isContentSettings=${isContentSettings}&articleLocation=${articleLocation}`,
  //   headers: {
  //     orgId: orgId,
  //     location: 'us'
  //   }
  // });
  const cacheOptions = useCache
    ? {
        ttl: 1000 * 60 * 5 // cache for 5 minutes
      }
    : false; // bypass cache

  return axiosCached.get(
    `${process.env.REACT_APP_API}/getArticleByIdNew/${articleId}?isContentSettings=${isContentSettings}&articleLocation=${articleLocation}`,
    {
      headers: {
        orgId: orgId
      },
      cache: false
    }
  );
};

const updateInsightByArticleId = ({
  orgId,
  articleId,
  isContentSettings,
  articleLocation,
  grpId
}: {
  orgId: string;
  articleId: string;
  isContentSettings: boolean;
  articleLocation: any;
  grpId?: string;
}) => {
  const grpQuery = grpId ? `&grpId=${grpId}` : '';
  return axiosCached.post(
    `${process.env.REACT_APP_API}/updateInsightByArticleId/${articleId}?isContentSettings=${isContentSettings}&articleLocation=${articleLocation}${grpQuery}`,
    {
      headers: {
        orgId: orgId
      },
      cache: false
    }
  );
};

const articleAction = async ({ orgId, articleId, data }: { orgId: string; articleId: string; data: object }) => {
  try {
    // const response = await axios({
    //   method: 'post',
    //   url: `${process.env.REACT_APP_API}/articleAction?articleId=${articleId}`,
    //   headers: {
    //     orgId: orgId,
    //     location: 'us'
    //   },
    //   data
    // });

    const response = await axiosCached.post(`${process.env.REACT_APP_API}/articleAction?articleId=${articleId}`, data, {
      headers: {
        orgId: orgId
      },
      cache: false
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const DeleteArticle = async ({ orgId, articleId, groupId }: { orgId: string; articleId: string; groupId: string }) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/group/${groupId}/deleteArticle?articleId=${articleId}`,
      headers: {
        orgId: orgId
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete an org-wide resource (no program group). Mirrors createOrgArticle's org-scoped
// endpoint — the group-scoped deleteArticle can't reach createdGroup:[] resources.
const DeleteOrgArticle = async ({
  authId,
  articleId,
  location
}: {
  authId: string;
  articleId: string;
  location?: string;
}) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API}/org/${authId}/resources/${articleId}`,
      headers: {
        orgId: authId,
        // Forward the region so EU/other-region orgs hit the right database.
        ...(location ? { location } : {})
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getMentorHelpfulTips = async ({ orgId }: { orgId: string }) => {
  // try {
  //   const response = await axios({
  //     method: 'get',
  //     url: `${process.env.REACT_APP_API}/getMentorHelpfulTips?helpSettings=false`,
  //     headers: {
  //       orgId: orgId,
  //       location: 'us'
  //     }
  //   });
  //   return response;
  // } catch (error) {
  //   throw error;
  // }

  try {
    const response = await axiosCached.get(`${process.env.REACT_APP_API}/getMentorHelpfulTips?helpSettings=false`, {
      headers: {
        orgId: orgId
      },
      cache: {
        ttl: 1000 * 60 * 5
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};
const getHelpfulTips = async ({ groupId, role, location }: { groupId: string; role: string; location: string }) => {
  // try {
  //   const response = await axios({
  //     method: 'get',
  //     url: `${process.env.REACT_APP_API}/getMentorHelpfulTips?helpSettings=false`,
  //     headers: {
  //       orgId: orgId,
  //       location: 'us'
  //     }
  //   });
  //   return response;
  // } catch (error) {
  //   throw error;
  // }

  try {
    const response = await axiosCached.get(`${process.env.REACT_APP_API}/helpfulTip?role=${role}&grpId=${groupId}`, {
      headers: {
        groupId: groupId,
        location: location
      },
      cache: {
        ttl: 1000 * 60 * 5
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// Edit an org-wide resource (no program group). Mirrors createOrgArticle/deleteOrgArticle's
// org-scoped endpoint; also powers the "Visible to others" toggle for org resources.
const EditOrgArticle = async ({
  authId,
  articleId,
  data,
  location
}: {
  authId: string;
  articleId: string;
  data: FormData;
  location?: string;
}) => {
  try {
    const response = await axios({
      method: 'patch',
      url: `${process.env.REACT_APP_API}/org/${authId}/resources/${articleId}`,
      data,
      headers: {
        orgId: authId,
        // Forward the region so EU/other-region orgs hit the right database.
        ...(location ? { location } : {})
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const editArticle = async ({
  orgId,
  articleId,
  data,
  groupId,
  helpSettings,
  location
}: {
  orgId: string;
  articleId: string;
  data: FormData;
  groupId: string;
  helpSettings: boolean;
  location?: string;
}) => {
  try {
    // const response = await axios({
    //   method: 'patch',
    //   url: `${process.env.REACT_APP_API}/group/${groupId}/updateArticle?articleId=${articleId}&helpSettings=${helpSettings}`,
    //   headers: {
    //     orgId: orgId,
    //     location: 'us'
    //   },
    //   data
    // });

    const response = await axiosCached.patch(
      `${process.env.REACT_APP_API}/group/${groupId}/updateArticle?articleId=${articleId}&helpSettings=${helpSettings}&articleLocation=${location}`,
      data,
      {
        headers: {
          orgId: orgId
        },
        cache: false
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Matches

const getListToAssignMatch = ({
  orgId,
  userId,
  grpId,
  data,
  isMatchingFields
}: {
  orgId: string;
  userId: string;
  grpId: string;
  data: object;
  isMatchingFields: boolean;
}) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/${userId}/group/${grpId}/matches/recommendations?isMatchingFields=${isMatchingFields}`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/${userId}/group/${grpId}/matches/recommendations?isMatchingFields=${isMatchingFields}`,
    data,
    {
      headers: {
        orgId: orgId
      },
      cache: false
    }
  );
};

const getAIMatchSuggestions = ({
  orgId,
  assigneeId,
  grpId,
  assigneeRole,
  objectivesHardFilter,
  location
}: {
  orgId: string;
  assigneeId: string;
  grpId: string;
  assigneeRole: 'Mentee' | 'Mentor';
  objectivesHardFilter?: boolean;
  location?: string;
}) => {
  const params = new URLSearchParams();
  params.set('objectivesHardFilter', objectivesHardFilter ? 'true' : 'false');
  return axiosCached.post(
    `${process.env.REACT_APP_API}/${assigneeId}/group/${grpId}/matches/ai-suggestions?${params.toString()}`,
    { assigneeRole },
    {
      headers: {
        orgId: orgId,
        ...(location ? { location } : {})
      },
      cache: false,
      // AI ranking of the candidate pool can take ~30–70s; the BE OpenAI call itself
      // allows up to 180s. Keep the client well above the typical worst case so the
      // request isn't aborted mid-flight (was 60000, which canceled ~64s responses).
      timeout: 120000
    }
  );
};

const assignAMatch = ({ orgId, grpId, data }: { orgId: string; grpId: string; data: object }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/matches/assignAMatch`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/matches/assignAMatch`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const assignAMatchByObjective = ({ orgId, grpId, data }: { orgId: string; grpId: string; data: object }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/matches/assignAMatch`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/matches/assignAMatchByObjective`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const autoMatch = ({ orgId, grpId, data }: { orgId: string; grpId: string; data: object }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/matches/autoMatch`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/matches/autoMatch`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const confirmAllMatches = ({ orgId, grpId }: { orgId: string; grpId: string }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/confirmAllMatches`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/group/${grpId}/confirmAllMatches`,
    {},
    {
      headers: {
        orgId: orgId
      },
      cache: false // Setting cache to false to disable caching
    }
  );
};

const confirmMatch = ({ orgId, grpId, data }: { orgId: string; grpId: string; data: object }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/confirmMatch`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/confirmMatch`, data, {
    headers: {
      orgId: orgId
    },
    cache: false // Setting cache to false to disable caching
  });
};

const getAllMatchesSetting = ({ orgId, grpId }: { orgId: string; grpId: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/getAllMatchesSetting`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/getAllMatchesSetting`, {
    headers: {
      orgId: orgId
    },
    cache: false // Setting cache to false to disable caching
  });
};

const removeMatch = ({ orgId, confirmMatchId, grpId }: { orgId: string; confirmMatchId: string; grpId: string }) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/endMatch/${confirmMatchId}`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });

  return axiosCached.patch(`${process.env.REACT_APP_API}/group/${grpId}/endMatch/${confirmMatchId}`, null, {
    headers: {
      orgId: orgId
    },
    cache: false // Setting cache to false to disable caching
  });
};

const getMatchProfile = ({ orgId, confirmMatchId }: { orgId: string; confirmMatchId: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getMatchProfile/${confirmMatchId}`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getMatchProfile/${confirmMatchId}`, {
    headers: {
      orgId: orgId
    },
    cache: false // Setting cache to false to disable caching
  });
};

const defaultMatchRequest = ({
  grpId,
  mentorId,
  value,
}: {
  grpId: string;
  mentorId: string;
  value: boolean;
}) => {
  const data = { mentorId, value };

  return axiosCached.put(
    `${process.env.REACT_APP_API}/group/${grpId}/matchByDefault`,
    data,
    { cache: false }
  );
};


// -----------
const getUserProfile = () => {
  // return axios({
  //   method: 'GET',
  //   url: `${process.env.REACT_APP_API}/getUserProfile`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getUserProfile`, {
    cache: false
  });
};

const updateUserProfile = ({
  data,
  orgId
}: {
  data: FormData | Record<string, unknown>;
  orgId: string;
}) => {
  return axiosCached.patch(`${process.env.REACT_APP_API}/UpdateUserProfile`, data, {
    headers: {
      orgId: orgId
    },
    cache: false // Setting cache to false to disable caching
  });
};

const updateUserMemberAttributes = (data: {
  memberAttributes: string[];
  memberAttributesChanged: boolean;
  /**
   * Org attribute LIST ids the member answered with "None of these apply to
   * me". Optional: callers that don't collect it (legacy profile save paths)
   * omit it, and the BE then leaves whatever the member already answered
   * alone rather than clearing it.
   */
  declinedListIds?: string[];
  /**
   * "Role in <team>" answers: a role id, or null for "None of these". Optional:
   * left out, the member's team roles stay as they are.
   */
  teamRoles?: Array<{ teamValueId: string; roleId: string | null }>;
}) => {
  return axiosCached.put(`${process.env.REACT_APP_API}/users/me/memberAttributes`, data, {
    cache: false
  });
};

const updateSocialLinks = ({ orgId, data }: { orgId: string; data: Social }) => {
  return axios({
    method: 'patch',
    url: `${process.env.REACT_APP_API}/updateSocialLinks`,
    headers: {
      orgId: orgId
    },
    data
  });
};

const updateDisability = ({ orgId, data }: { orgId: string; data: string[] }) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/updateUserDisability`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data: { disability: data }
  // });

  return axiosCached.patch(
    `${process.env.REACT_APP_API}/updateUserDisability`,
    { disability: data },
    {
      headers: {
        orgId: orgId
      },
      cache: false // Setting cache to false to disable caching
    }
  );
};

const getEducationAndSkills = ({ userId, location }: { userId: string; location: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getUserEducation?userId=${userId}`,
  //   headers: {
  //     location
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getUserEducation?userId=${userId}`, {
    headers: {
      location
    },
    cache: false
  });
};

export interface Education1 {
  [key: string]: string | string[] | null;
  minor: string[] | null;
  major: string;
  graduation_date: string;
  university: string;
  department: string;
}

const addEducationAndSkills = ({
  userId,
  location,
  formData
}: {
  userId: string;
  location: string;
  formData: FieldValues;
}) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/addUserEducation?userId=${userId}`,
  //   headers: {
  //     location
  //   },
  //   data: formData
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/addUserEducation?userId=${userId}`, formData, {
    headers: {
      location: location
    },
    cache: false // Setting cache to false to disable caching
  });
};

const updateEducationAndSkills = ({
  userId,
  location,
  formData,
  id
}: {
  userId: string;
  location: string;
  formData: Education1;
  id: string;
}) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/updateUserEducation?userId=${userId}&educationId=${id}`,
  //   headers: {
  //     location
  //   },
  //   data: formData
  // });

  return axiosCached.patch(
    `${process.env.REACT_APP_API}/updateUserEducation?userId=${userId}&educationId=${id}`,
    formData,
    {
      headers: {
        location: location
      },
      cache: false // Setting cache to false to disable caching
    }
  );
};

const deleteEducation = ({ userId, location, id }: { userId: string; location: string; id: string }) => {
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/deleteUserEducation?userId=${userId}&educationId=${id}`,
    headers: {
      location
    }
  });
};

// const getWorkHistory = ({ userId, location }: { userId: string; location: string }) => {
//   return axios({
//     method: 'get',
//     url: `${process.env.REACT_APP_API}/getUserWorkHistory?userId=${userId}`,
//     headers: {
//       location
//     }
//   });

// };

const getWorkHistory = ({ userId, location }: { userId: string; location: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/getUserWorkHistory?userId=${userId}`, {
    headers: {
      location
    },
    cache: false
  });
};

const deleteAllEducationAndWorkHistory = ({ userId, deleteType }: { userId: string; deleteType: string }) => {
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/deleteAllWorkHistoryAndEducation?userId=${userId}&deleteType=${deleteType}`
  });
};

const addWorkHistory = ({
  userId,
  location,
  formData
}: {
  userId: string;
  location: string;
  formData: IWorkHistory;
}) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/addUserWorkHistory?userId=${userId}`,
  //   headers: {
  //     location
  //   },
  //   data: formData
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/addUserWorkHistory?userId=${userId}`, formData, {
    headers: {
      location: location
    },
    cache: false // Setting cache to false to disable caching
  });
};

const updateWorkHistory = ({
  userId,
  location,
  formData,
  id
}: {
  userId: string;
  location: string;
  formData: IWorkHistory;
  id: string;
}) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/updateUserWorkHistory?userId=${userId}&workHistoryId=${id}`,
  //   headers: {
  //     location
  //   },
  //   data: formData
  // });

  return axiosCached.patch(
    `${process.env.REACT_APP_API}/updateUserWorkHistory?userId=${userId}&workHistoryId=${id}`,
    formData,
    {
      headers: {
        location
      },
      cache: false
    }
  );
};

const deleteWorkHistory = ({ userId, location, id }: { userId: string; location: string; id: string }) => {
  // return axios({
  //   method: 'delete',
  //   url: `${process.env.REACT_APP_API}/deleteUserWorkHistory?userId=${userId}&workHistoryId=${id}`,
  //   headers: {
  //     location
  //   }
  // });

  return axiosCached.delete(`${process.env.REACT_APP_API}/deleteUserWorkHistory?userId=${userId}&workHistoryId=${id}`, {
    headers: {
      location
    },
    cache: false
  });
};

const getTags = (value?: string) => {
  if (typeof value === 'undefined') {
    value = '';
  }
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getTagsList?value=${value}`,
  //   headers: {
  //     location: getUserDetails().location
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getTagsList?value=${value}`, {
    cache: false
  });
};

const updateGroupPic = ({ orgId, location, formData }: { orgId: string; location: string; formData: FormData }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/groupChatPicUpload`,
  //   headers: {
  //     orgId,
  //     location
  //   },
  //   data: formData
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/groupChatPicUpload`, formData, {
    headers: {
      orgId,
      location
    },
    cache: false
  });
};

const addUserVideoUpload = ({ orgId, data }: { orgId: string; data: FormData }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/updateUserVideoIntro`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const deleteVideoIntro = ({ userId }: { userId: string }) => {
  // return axios({
  //   method: 'delete',
  //   url: `${process.env.REACT_APP_API}/deleteVideoBio/${userId}`
  // });

  return axiosCached.delete(`${process.env.REACT_APP_API}/deleteVideoBio/${userId}`, {
    cache: false
  });
};

const getGroupByOrgId = (orgId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/org/${orgId}`,
  //   headers: {}
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/org/${orgId}`, {
    cache: false
  });
};

const getAllGroups = ({
  orgId,
  grpId,
  loc,
  useCache
}: {
  orgId: string;
  grpId: string;
  loc?: string;
  useCache?: boolean;
}) => {
  const url = `${process.env.REACT_APP_API}/groups/getAll`;
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/groups/getAll`,
  //   headers: { location: loc },
  //   data: {
  //     orgId,
  //     grpId,
  //     pagination: {
  //       pageIndex: 1,
  //       pageSize: 100,
  //       sort: { direction: 'asc', column: 'name' }
  //     }
  //   }
  // });
  const data = {
    orgId,
    grpId,
    pagination: {
      pageIndex: 1,
      pageSize: 100,
      sort: { direction: 'asc', column: 'name' }
    }
  };

  const cacheOptions = useCache
    ? {
        ttl: 1000 * 60 * 5 // cache for 5 minutes
      }
    : false; // bypass cache

  return axiosCached.post(url, data, {
    // headers: {
    //   location: loc
    // },
    cache: { ttl: 1000 * 60 * 5 }
  });
};

const getGroupsOverview = ({ orgId, grpId, loc }: { orgId: string; grpId: string; loc?: string }) => {
  const url = `${process.env.REACT_APP_API}/groups/overview`;
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/groups/overview`,
  //   headers: { location: loc },
  //   data: {
  //     grpId,
  //     orgId
  //   }
  // });

  return axiosCached.post(
    url,
    {
      data: {
        grpId,
        orgId
      }
    },
    {
      cache: false
    }
  );
};

const fetchMembersInsights = (grpId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/insights/metrics`,
  //   headers: {}
  // });
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/insights/metrics`, {
    headers: {},
    cache: {
      ttl: 1000 * 60 * 1
    }
  });
};

const getProgramInsightsV3 = (grpId: string, params?: { from?: number; to?: number }) => {
  const query: string[] = [];
  if (params?.from !== undefined && params?.from !== null) query.push(`from=${params.from}`);
  if (params?.to !== undefined && params?.to !== null) query.push(`to=${params.to}`);
  const qs = query.length ? `?${query.join('&')}` : '';
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/insights-v3${qs}`, {
    headers: {},
    cache: false
  });
};

const getMentorshipInsightsV3 = (grpId: string, params?: { from?: number; to?: number }) => {
  const query: string[] = [];
  if (params?.from !== undefined && params?.from !== null) query.push(`from=${params.from}`);
  if (params?.to !== undefined && params?.to !== null) query.push(`to=${params.to}`);
  const qs = query.length ? `?${query.join('&')}` : '';
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/mentorship-insights-v3${qs}`, {
    headers: {},
    cache: false
  });
};

const postAimdHeartbeat = (grpId: string, activeSeconds: number) => {
  return axios.post(`${process.env.REACT_APP_API}/group/${grpId}/aimd/heartbeat`, { activeSeconds });
};

/**
 * ATC: flushes the seconds the heartbeat hasn't sent yet and freezes the
 * program's build time (`aimdCreateSeconds`) at the "Create" click. Same route
 * as the heartbeat — `final` switches the BE to the freeze path. Responds with
 * `{ seconds, addedSeconds, alreadyFinalized }`.
 */
const postAimdFinalize = (grpId: string, activeSeconds: number) => {
  return axios.post(`${process.env.REACT_APP_API}/group/${grpId}/aimd/heartbeat`, {
    activeSeconds,
    final: true
  });
};

const fetchChartInsights = (grpId: string) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/chartInsights`,
  //   headers: {}
  // });

  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/chartInsights`,
  //   headers: {}
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/group/${grpId}/chartInsights`,
    {},
    {
      headers: {},
      cache: {
        ttl: 1000 * 60 * 1
      } // Setting cache to false to disable caching
    }
  );
};

const fetchInsightsMetricsCount = (grpId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/insights/metrics/count`,
  //   headers: {}
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/insights/metrics/count`, {
    headers: {},
    cache: {
      ttl: 1000 * 60 * 1
    } // Setting cache to false to disable caching
  });
};

const createLevel = ({ name, orgId, parent }: { name: string; orgId: string; parent: string }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/level/create`,
  //   headers: {},
  //   data: { orgId, name, parent }
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/level/create`,
    { orgId, name, parent },
    {
      cache: false
    }
  );
};

const createGroup = ({
  name,
  orgId,
  parent,
  location,
  // Optional fields used by the Learning Framework drawer (Design Now /
  // Design Later) so the new program lands with the right pillar, type,
  // launch date, owner, and audience in one call instead of follow-up
  // PATCHes. Legacy callers ignore these.
  model,
  programType,
  learningPillarId,
  launchDate,
  ownerId,
  memberAttributes,
  audienceRules,
  enrollmentMode,
  awaitingInviteFinish,
  roleIds,
  capabilityIds,
  format,
  guided,
  goalLessons,
  audienceGroups
}: {
  name: string;
  orgId: string;
  parent: string;
  location?: string;
  model?: string;
  programType?: string;
  learningPillarId?: string | null;
  launchDate?: number | null;
  ownerId?: string | null;
  /** @deprecated flat audience — sent alongside `audienceRules` so an older BE
   *  build still enrolls correctly. */
  memberAttributes?: string[];
  /** Per-list audience rules (any/all within a list, AND across lists). */
  audienceRules?: ProgramAudienceRule[];
  // Enrollment intent from the Elliott chat's audience step. When sent, the
  // BE executes it at create: 'proceed' enrolls by memberAttributes,
  // 'auto-enroll' enrolls every org member, 'manual' skips enrollment.
  // 'roles': a program for roles (the build flow).
  enrollmentMode?: 'proceed' | 'auto-enroll' | 'manual' | 'roles' | null;
  // Creation-flow revamp: store the audience only — nobody enrols until
  // Invite & Finish on the Members step (overrides enrollmentMode at create).
  awaitingInviteFinish?: boolean;
  // The build flow: what the program is built from. A Role Excellence program
  // with roles is for their holders only (the BE stores it with enrollmentMode
  // 'roles' and no attribute audience). Sent only by the build flow.
  roleIds?: string[];
  capabilityIds?: string[];
  format?: 'course' | 'shortCourse' | 'brief' | null;
  guided?: boolean;
  /** Every goal a lesson of its own (shared capabilities, PRD R10): the build flow sends it. */
  goalLessons?: boolean;
  /**
   * Audience Requirements (DA-5056): the Read & Assess and Read Only groups.
   * Sent, they are the audience: the BE derives roleIds (every role they
   * name), audienceRules, memberAttributes and enrollmentMode from them and
   * ignores any sent beside them; 409 when they don't go together (overlaps).
   */
  audienceGroups?: ProgramAudienceGroups;
}) => {
  const body: Record<string, any> = { orgId, name, parent };
  if (model !== undefined) body.model = model;
  if (programType !== undefined) body.programType = programType;
  if (learningPillarId !== undefined) body.learningPillarId = learningPillarId;
  if (launchDate !== undefined) body.launchDate = launchDate;
  if (ownerId !== undefined) body.ownerId = ownerId;
  if (memberAttributes !== undefined) body.memberAttributes = memberAttributes;
  // Only send audienceRules when there are actually rules. The production BE
  // validates group/create with a strict schema that REJECTS unknown keys
  // ("audienceRules is not allowed", Joi object.unknown) rather than ignoring
  // them — so sending an empty `audienceRules: []` (which the drawer always
  // seeds at create time) 400s the whole request and blocks ALL program
  // creation. Omitting the empty array keeps creation working on the current BE
  // while staying forward-compatible: once the BE accepts audienceRules, a
  // non-empty set flows through unchanged. The flat `memberAttributes` still
  // carries the audience, so nothing is lost at create. See PRD:
  // docs/PRD-group-create-audienceRules-400.md
  if (audienceRules !== undefined && audienceRules.length > 0) body.audienceRules = audienceRules;
  if (enrollmentMode != null) body.enrollmentMode = enrollmentMode;
  if (awaitingInviteFinish) body.awaitingInviteFinish = true;
  if (goalLessons) body.goalLessons = true;
  if (roleIds !== undefined) body.roleIds = roleIds;
  if (capabilityIds !== undefined) body.capabilityIds = capabilityIds;
  if (format !== undefined) body.format = format;
  if (guided !== undefined) body.guided = guided;
  if (audienceGroups !== undefined) body.audienceGroups = audienceGroups;

  return axiosCached.post(`${process.env.REACT_APP_API}/group/create`, body, {
    cache: false,
    headers: location ? { location } : {}
  });
};

const deleteGroup = (grpId: string) => {
  // return axios({
  //   method: 'delete',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}`
  // });

  return axiosCached.delete(`${process.env.REACT_APP_API}/group/${grpId}`, {
    cache: false
  });
};

// const getGroupDetails = (grpId: string, loc?: string) => {
//   // return axios({
//   //   method: 'get',
//   //   headers: loc ? { location: loc } : {},
//   //   url: `${process.env.REACT_APP_API}/group/${grpId}`
//   // });

//   return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}`, {
//     // headers: loc ? { location: loc } : {},
//     cache: {
//       ttl: 1000 * 1 * 1
//     } // Setting TTL to 0 to force fetching from the network
//   });

// };

const getGroupDetails = (grpId: string, loc?: string, useCache?: boolean) => {
  // Set the headers based on whether `loc` is provided
  const headers = loc ? { location: loc } : {};

  // Set cache options based on the useCache parameter
  const cacheOptions = useCache
    ? {
        ttl: 1000 * 60 * 15 // cache for 5 minutes
      }
    : { ttl: 1000 * 1 * 1 }; // bypass cache

  // const cacheOptions =  {
  //   ttl: 1000 * 60 * 15 // cache for 5 minutes
  // } // bypass cache

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}`, {
    headers: headers,
    cache: cacheOptions
  });
};

// `fresh` reads past the cache, for a list read right after a write (the Program Editor's People tab).
const getGroupUsers = (
  grpId: string,
  pageNumber?: number,
  pageSize?: number,
  name?: string,
  opts: { fresh?: boolean } = {}
) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/users/getAll`
  // });

  const params: Record<string, number | string> = {};
  if (pageNumber && pageSize) {
    params.pageNumber = pageNumber;
    params.pageSize = pageSize;
  }
  if (name != null && String(name).trim() !== '') {
    params.name = String(name).trim();
  }
  const useParams = Object.keys(params).length > 0 ? params : undefined;

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/users/getAll`, {
    params: useParams,
    cache: opts.fresh ? false : { ttl: 1000 * 1 * 1 }
  });
};

interface IGroupUserData {
  firstName: string;
  lastName: string;
  mobileNumber?: number | string;
  role: any;
  email: string;
}

const inviteUserToAGroup = ({ formData, grpId, orgId }: { formData: IGroupUserData; grpId: string; orgId: string }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/${orgId}/group/${grpId}`,
  //   data: formData
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/${orgId}/group/${grpId}`, formData, {
    cache: false
  });
};

// For Bulk upload Files
const bulkFilesUpload = ({
  // tokens,
  orgId,
  grpId,
  data
}: {
  // tokens: { id_token: string };
  orgId: string;
  grpId: string;
  data: FormData;
}) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/${orgId}/group/${grpId}/bulkUpload`,
  //   headers: {},
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/${orgId}/group/${grpId}/bulkUploadMembers`, data, {
    headers: {},
    cache: false
  });
};

const getGroupMemberAttributes = ({ grpId }: { grpId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/groups/${grpId}/memberAttributes`, {
    cache: false
  });
};

const isObjectId = (v: string) => /^[a-f0-9]{24}$/i.test(v);

const updateGroupMemberAttributes = ({
  grpId,
  data,
  enroll
}: {
  grpId: string;
  data: GroupMemberAttributesPutItem[];
  /** Creation flow only: false = save the selection WITHOUT enrolling matching
   *  members (enrollment then happens explicitly on "Invite & Finish").
   *  Omitted/true keeps the legacy enroll-on-save behaviour. */
  enroll?: boolean;
}) => {
  // Sanitize: never send raw ObjectIds as name or value (prevents catalog corruption)
  const sanitized = Array.isArray(data)
    ? data.filter((group: any) => {
        if (!group?.name || isObjectId(group.name)) return false;
        if (Array.isArray(group.values)) {
          group.values = group.values.filter(
            (v: any) => v?.value && !isObjectId(v.value)
          );
        }
        return true;
      })
    : data;

  return axiosCached.put(
    `${process.env.REACT_APP_API}/groups/${grpId}/memberAttributes${enroll === false ? '?enroll=false' : ''}`,
    sanitized,
    { cache: false }
  );
};

// Basic Settings Page............//
interface IGroupBasicSettingsData {
  name: string;
  endDate: Date;
  programType: string;
  logo: File;
  model: string;
}

const addBasicSettings = ({ formData, grpId }: { formData: IGroupBasicSettingsData; grpId: string }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/basicSettings`,
  //   data: formData
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/basicSettings`, formData, {
    cache: false
  });
};

const removeUserFromGroup = ({ grpId, userId }: { grpId: string; userId: string }) => {
  // return axios({
  //   method: 'delete',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/removeParticipant/${userId}`
  // });

  return axiosCached.delete(`${process.env.REACT_APP_API}/group/${grpId}/removeParticipant/${userId}`, {
    cache: false
  });
};

const updateGroupInfo = ({ orgId, grpId, formData }: { orgId: string; grpId: string; formData: FormData }) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/basicSettings`,
  //   headers: {
  //     orgId
  //   },
  //   data: formData
  // });

  return axiosCached.patch(`${process.env.REACT_APP_API}/group/${grpId}/basicSettings`, formData, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

/** Admin lock toggle for a program. Locked programs still show to learners but
 *  Continue / Improve Performance are disabled (and blocked BE-side). */
const updateProgramLock = ({ grpId, locked }: { grpId: string; locked: boolean }) => {
  return axios.patch(`${process.env.REACT_APP_API}/group/${grpId}/lock`, { locked });
};

const getAllMatches = ({
  orgId,
  groupId,
  name,
  pageNumber,
  pageSize,
  grouped = true
}: {
  orgId: string;
  groupId: string;
  name?: string;
  pageNumber?: number;
  pageSize?: number;
  grouped?: boolean;
}) => {
  const params: Record<string, number | string | boolean> = {};
  if (grouped) {
    params.grouped = true;
  }
  if (pageNumber != null && pageSize != null) {
    params.pageNumber = pageNumber;
    params.pageSize = pageSize;
  }
  if (name != null && String(name).trim() !== '') {
    params.name = String(name).trim();
  }
  const useParams = Object.keys(params).length > 0 ? params : undefined;

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/matches/getAll`, {
    headers: {
      orgId: orgId
    },
    params: useParams,
    cache: false
  });
};
export interface IOptionalFields {
  gender: boolean;
  ethnicity: boolean;
  firstGenerationStudent: boolean;
  disabilityType: boolean;
  dob: boolean;
  country: boolean;
  workHistory: boolean;
  educationHistory: boolean;
  hobbiesInterests: boolean;
  headshot: boolean;
}

const updateOptionalFields = ({ grpId, data }: { grpId: string; data: any }) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/optionalFields`,
  //   headers: {},
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/optionalFields`, data, {
    headers: {},
    cache: false
  });
};

const updateAllMatches = ({ grpId, orgId, data }: { grpId: string; orgId: string; data: object }) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/updateMatchingSettings`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.patch(`${process.env.REACT_APP_API}/group/${grpId}/updateMatchingSettings`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getProgramConfiguration = ({ grpId }: { grpId: string }) => {
  return axiosCached.get(
    `${process.env.REACT_APP_API}/v3/programs/${grpId}/configuration`,
    { cache: false }
  );
};

const updateProgramConfiguration = ({
  grpId,
  data
}: {
  grpId: string;
  data: object;
}) => {
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/v3/programs/${grpId}/configuration`,
    data,
    { cache: false }
  );
};

const getAllMatchesSettings = ({ grpId, orgId }: { grpId: string; orgId: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/getAllMatchesSetting`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/getAllMatchesSetting`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const revokeGroupInvitation = ({ orgId, invitedId }: { orgId: string; invitedId: string }) => {
  // return axios({
  //   method: 'delete',
  //   url: `${process.env.REACT_APP_API}/${orgId}/user/${invitedId}`,
  //   headers: {}
  // });

  return axiosCached.delete(`${process.env.REACT_APP_API}/${orgId}/user/${invitedId}`, {
    headers: {},
    cache: false
  });
};

const getUserProfileInAGroup = (grpId: string, userId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/user/${userId}`,

  //   headers: {
  //     // authorization: `Bearer ${token}`,
  //     // orgId: orgId !== "" ? orgId : null,
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/user/${userId}`, {
    headers: {
      // authorization: `Bearer ${token}`,
      // orgId: orgId !== "" ? orgId : null,
    },
    cache: false
  });
};

const getAllGroupsByUserId = (userId: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getAllGroupsByUserId?userId=${userId}`,

  //   headers: {
  //     // authorization: `Bearer ${token}`,
  //     // orgId: orgId !== "" ? orgId : null,
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getAllGroupsByUserId?userId=${userId}`, {
    headers: {
      // authorization: `Bearer ${token}`,
      // orgId: orgId !== "" ? orgId : null,
    },
    cache: false
  });
};

const getUserCommunityPeersList = (orgId: string, location: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getUserCommunityPeersList`,
  //   headers: {
  //     // authorization: `Bearer ${token}`,
  //     orgId: orgId,
  //     location: location
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getUserCommunityPeersList`, {
    headers: {
      // authorization: `Bearer ${token}`,
      orgId: orgId,
      location: location
    },
    cache: false
  });
};

const getMentorsPeersHomePage = (orgId: string, location: string, groupId: string) => {
  // return axios({
  //     method: 'get',
  //     url: `${process.env.REACT_APP_API}/group/${groupId}/mentorsPeers`,
  //     headers: {
  //       // authorization: `Bearer ${token}`,
  //       orgId: orgId,
  //       location: location
  //     }
  //   });
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/mentorsPeers`, {
    headers: {
      orgId: orgId,
      location: location
      // Add other headers if needed
    },
    cache: {
      ttl: 1000 * 60 * 5 // Set TTL to 0 for no caching
    }
  });
};

const getMenteeListForMentor = (orgId: string, location: string, grpId: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/groups/${grpId}/menteeListForMentor`, {
    headers: {
      orgId: orgId,
      location: location
    },
    cache: false
  });
};

const getMenteesPeersHomePage = (orgId: string, location: string, groupId: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/MenteesPeers`, {
    headers: {
      orgId: orgId,
      location: location
      // Add other headers if needed
    },
    cache: {
      ttl: 1000 * 1 * 1 // Set TTL to 0 for no caching
    }
  });
};

const getMenteeInsights = (orgId: string, location: string, groupId: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/menteeInsights`, {
    headers: {
      orgId: orgId,
      location: location
      // Add other headers if needed
    },
    cache: false
    // cache: {
    //   ttl: 1000 * 1 * 1 // Set TTL to 0 for no caching
    // }
  });
};

const getMyMentorsForTask = ({
  orgId,
  groupId,
  level,
  task
}: {
  orgId: string;
  groupId: string;
  level: string;
  task: string;
}) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${groupId}/level/${level}/task/${task}/mentors`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/level/${level}/task/${task}/mentors`, {
    headers: {
      orgId: orgId
    },
    cache: {
      ttl: 1000 * 1 * 1 // Set TTL to 0 for no caching
    }
  });
};

const getMyMentors = ({ orgId, groupId }: { orgId: string; groupId: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${groupId}/myMentors`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/myMentors`, {
    headers: {
      orgId: orgId
      // Add other headers if needed
    },
    cache: false
  });
};

// Consolidated mentor-portfolio endpoint: returns the mentee list plus the
// per-match stats (messages/meetings) in a single call, replacing the old
// "getMyMentees + one getMatchProfile per match" fan-out.
const getMentorMatches = ({ orgId, groupId }: { orgId: string; groupId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/mentorMatches`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getMyMentees = ({ orgId, groupId }: { orgId: string; groupId: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${groupId}/myMentees`,
  //   headers: {
  //     orgId: orgId
  //   }
  // });
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${groupId}/myMentees`, {
    headers: {
      orgId: orgId
      // Add other headers if needed
    },
    cache: false
  });
};

const getMenteeProgress = ({ orgId, grpId }: { orgId: string; grpId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/menteeMentorshipProgress`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const updateOrganizationSettings = ({ orgId, formData }: { orgId: string; formData: FormData }) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/org/${orgId}/settings`,
  //   headers: {},
  //   data: formData
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/org/${orgId}/settings`, formData, { cache: false });
};

const saveAnswers = ({
  groupId,
  levelId,
  taskId,
  menteeAsmtAnswer,
  MCQanswers,
  answers,
  cancelToken
}: {
  groupId: string;
  levelId: string;
  taskId: string;
  menteeAsmtAnswer: string;
  MCQanswers: any;
  answers: any;
  cancelToken: any;
}) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/task/${taskId}/saveAnswers`,
  //   data: {
  //     menteeAsmtAnswer,
  //     menteeAns
  //   },
  //   cancelToken: cancelToken
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/task/${taskId}/saveAnswers`,
    {
      menteeAsmtAnswer,
      answers,
      MCQanswers
    },
    {
      cancelToken: cancelToken,
      cache: false // Setting cache to false to disable caching
    }
  );
};

// ─── Elliott course redesign (docs/elliott-course-redesign-backend.md) ────────

/** Learner payload for the conversational lesson (content, case studies, sim state, quiz sans answers, nav). */
const getElliottLesson = ({ groupId, levelId, taskId }: { groupId: string; levelId: string; taskId: string }) =>
  axiosCached.get(`${process.env.REACT_APP_API}/elliott-lesson/${groupId}/${levelId}/${taskId}`, { cache: false });

/** Evaluate one Live Simulation attempt (5-cap enforced server-side). */
const evaluateElliottSimulation = ({
  groupId,
  levelId,
  taskId,
  response
}: {
  groupId: string;
  levelId: string;
  taskId: string;
  response: string;
}) =>
  axiosCached.post(
    `${process.env.REACT_APP_API}/elliott-simulation/${groupId}/${levelId}/${taskId}`,
    { response },
    { cache: false }
  );

/** Elliott voice (Live Simulation): server TTS — { audioBase64, mime, provider }.
 *  503 VOICE_UNAVAILABLE = no key configured; the FE falls back to the browser voice.
 *  One sentence-sized chunk per call; the providers answer in 1–4 s, so a hung
 *  request must not stall the turn — the engine retries once, then falls back. */
const elliottVoiceTts = ({ text }: { text: string }) =>
  axiosCached.post(`${process.env.REACT_APP_API}/elliott-voice/tts`, { text }, { cache: false, timeout: 20000 });

/** Elliott voice (Live Simulation): server STT via OpenAI — one recorded learner turn → { text }.
 *  `context` (Elliott's last turn) biases the transcription toward the sim's domain. */
const elliottVoiceStt = ({ audioBase64, mime, context }: { audioBase64: string; mime: string; context?: string }) =>
  axiosCached.post(`${process.env.REACT_APP_API}/elliott-voice/stt`, { audioBase64, mime, context }, { cache: false });

/** Inline quiz grading — persistence still goes through saveAnswers on completion.
 *  `retake: true` records the next pass for a still-wrong question (Improve
 *  Performance flow, rationale-enabled programs only). */
const checkElliottQuizAnswer = ({
  groupId,
  levelId,
  taskId,
  questionId,
  answer,
  retake
}: {
  groupId: string;
  levelId: string;
  taskId: string;
  questionId: string;
  answer: string;
  retake?: boolean;
}) =>
  axiosCached.post(
    `${process.env.REACT_APP_API}/elliott-quiz-check/${groupId}/${levelId}/${taskId}`,
    { questionId, answer, ...(retake ? { retake: true } : {}) },
    { cache: false }
  );

/** Open the next Live Scenario retake round (Improve Performance). Returns { round, intro, attemptsRemaining }. */
const openElliottSimulationRetake = ({
  groupId,
  levelId,
  taskId
}: {
  groupId: string;
  levelId: string;
  taskId: string;
}) =>
  axiosCached.post(
    `${process.env.REACT_APP_API}/elliott-simulation-retake/${groupId}/${levelId}/${taskId}`,
    {},
    { cache: false }
  );

/**
 * An Improve Performance queue for one program — outstanding scenario/quiz items in program order. The caller's own by
 * default; admins pass memberId to read a member's, and the BE echoes memberId back when it honours it.
 */
const getElliottImproveQueue = ({ groupId, memberId }: { groupId: string; memberId?: string }) =>
  axiosCached.get(`${process.env.REACT_APP_API}/elliott-improve-queue/${groupId}`, {
    params: memberId ? { memberId } : undefined,
    cache: false
  });

/** Elliott's Assessment report (modules → lessons + flags + narratives) for one member in one program. */
const getElliottAssessment = ({ groupId, memberId }: { groupId: string; memberId: string }) =>
  axiosCached.get(`${process.env.REACT_APP_API}/elliott-assessment/${groupId}/${memberId}`, { cache: false });

/** Persist MANUAL admin edits to a lesson's Elliott sections (no AI) — stage-6 editor. */
const updateElliottSection = ({
  generationId,
  moduleIndex,
  lessonIndex,
  caseStudies,
  simulationRubric,
  simulationEnabled,
  caseStudiesEnabled,
  quizEnabled
}: {
  generationId: string;
  moduleIndex: number;
  lessonIndex: number;
  caseStudies?: Array<{ id?: string; title: string; sections: Array<{ label: string; text: string }> }>;
  /** null deletes the Roleplay (docs/PRD-capability-lesson-roleplays.md R9). */
  simulationRubric?: { brief: string; skill: string; strongPoints: string[]; weakPoints: string[] } | null;
  simulationEnabled?: boolean;
  caseStudiesEnabled?: boolean;
  quizEnabled?: boolean;
}) =>
  axiosCached.patch(
    `${process.env.REACT_APP_API}/program-generation/${generationId}/elliott-section`,
    { moduleIndex, lessonIndex, caseStudies, simulationRubric, simulationEnabled, caseStudiesEnabled, quizEnabled },
    { cache: false }
  );

/** Section-scoped "Improve with AI" for the stage-6 editor (caseStudies | simulation | quiz). */
const improveElliottSection = ({
  generationId,
  moduleIndex,
  lessonIndex,
  section,
  feedback,
  caseStudyIndex
}: {
  generationId: string;
  moduleIndex: number;
  lessonIndex: number;
  section: 'caseStudies' | 'simulation' | 'quiz';
  feedback: string;
  /** Scopes a caseStudies improve to a single card; omit to regenerate the whole set. */
  caseStudyIndex?: number;
}) =>
  axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${generationId}/improve-elliott-section`,
    { moduleIndex, lessonIndex, section, feedback, caseStudyIndex },
    { cache: false }
  );

/**
 * Task-scoped Elliott section edit — the published-program designer path
 * (manually-built and backfilled programs, no generation artifact). Persists
 * manual edits directly on the live template task.
 */
const updateElliottSectionOnTask = ({
  grpId,
  levelId,
  taskId,
  orgId,
  caseStudies,
  simulationRubric,
  simulationEnabled,
  caseStudiesEnabled,
  quizEnabled
}: {
  grpId: string;
  levelId: string;
  taskId: string;
  orgId: string;
  caseStudies?: Array<{ id?: string; title: string; sections: Array<{ label: string; text: string }> }>;
  /** null deletes the Roleplay (docs/PRD-capability-lesson-roleplays.md R9). */
  simulationRubric?: { brief: string; skill: string; strongPoints: string[]; weakPoints: string[] } | null;
  simulationEnabled?: boolean;
  caseStudiesEnabled?: boolean;
  quizEnabled?: boolean;
}) =>
  axiosCached.patch(
    `${process.env.REACT_APP_API}/elliott-section/${grpId}/${levelId}/${taskId}`,
    { caseStudies, simulationRubric, simulationEnabled, caseStudiesEnabled, quizEnabled },
    { cache: false, headers: { orgId } }
  );

/**
 * Task-scoped section "Improve with AI" (empty feedback = plain regenerate).
 * A quiz improve replaces task.MCQ on the BE — refetch the template afterwards.
 */
const improveElliottSectionOnTask = ({
  grpId,
  levelId,
  taskId,
  orgId,
  section,
  feedback,
  caseStudyIndex
}: {
  grpId: string;
  levelId: string;
  taskId: string;
  orgId: string;
  /** 'content' improves the top-level Lesson Content text (persists the new
   *  content + AI reasoning on the task and cascades the Elliott sections). */
  section: 'caseStudies' | 'simulation' | 'quiz' | 'content';
  feedback: string;
  /** Scopes a caseStudies improve to a single card; omit to regenerate the whole set. */
  caseStudyIndex?: number;
}) =>
  axiosCached.post(
    `${process.env.REACT_APP_API}/elliott-section/${grpId}/${levelId}/${taskId}`,
    { section, feedback, caseStudyIndex },
    { cache: false, headers: { orgId } }
  );

/**
 * Task-scoped "Generate Lesson Video" (post-creation editor) — independent of
 * any programGeneration artifact; quota is per program (3). Poll with
 * getTaskLessonVideoStatus.
 */
const generateTaskLessonVideo = ({
  grpId,
  levelId,
  taskId,
  orgId,
  prompt
}: {
  grpId: string;
  levelId: string;
  taskId: string;
  orgId: string;
  prompt: string;
}) =>
  axiosCached.post(
    `${process.env.REACT_APP_API}/group/${grpId}/level/${levelId}/task/${taskId}/generate-video`,
    { prompt },
    { cache: false, headers: { orgId } }
  );

const getTaskLessonVideoStatus = ({
  grpId,
  videoJobId,
  orgId
}: {
  grpId: string;
  videoJobId: string;
  orgId: string;
}) =>
  // Polled on a timer: see `vbPoll` for why these carry a timeout.
  axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/video-status/${videoJobId}`, {
    cache: false,
    timeout: 20000,
    headers: { orgId }
  });

const getAllPrograms = ({ orgId, userId = '' }: { orgId: string; userId?: string }) => {
  // console.log('called from index');
  // return axios.get(userId
  //   ? `${process.env.REACT_APP_API}/group/${grpId}/getAllTasks?userId=${userId}`
  //   : `${process.env.REACT_APP_API}/group/${grpId}/getAllTasks`
  // );

  return axiosCached.get(
    userId
      ? `${process.env.REACT_APP_API}/groups/${orgId}/programs/user?userId=${userId}`
      : `${process.env.REACT_APP_API}/groups/${orgId}/programs/user`,
    { cache: false }
  );
};

const getAllTasks = ({ grpId, userId = '' }: { grpId: string; userId?: string }) => {
  // console.log('called from index');
  // return axios.get(userId
  //   ? `${process.env.REACT_APP_API}/group/${grpId}/getAllTasks?userId=${userId}`
  //   : `${process.env.REACT_APP_API}/group/${grpId}/getAllTasks`
  // );

  return axiosCached.get(
    userId
      ? `${process.env.REACT_APP_API}/group/${grpId}/getAllTasks?userId=${userId}`
      : `${process.env.REACT_APP_API}/group/${grpId}/getAllTasks`,
    { cache: false }
  );
};

const getTask = ({
  groupId,
  levelId,
  taskId,
  userId
}: {
  groupId: string;
  levelId: string;
  taskId: string;
  userId: string;
}) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/task/${taskId}?userId=${userId}`
  // });

  return axiosCached.get(
    `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/task/${taskId}?userId=${userId}`,
    { cache: false }
  );
};

const getAllTemplates = ({ grpId }: { grpId: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/getAllTemplates`
  // });
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/getAllTemplates`, { cache: false });
};

const getAllLevels = ({ grpId, goalId }: { grpId: string; goalId: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/template/${goalId}/getAllLevels`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/template/${goalId}/getAllLevels`, {
    cache: false
  });
};

export interface IGoalData {
  programType: string;
  programKPIS: string;
  goalName: string;
  new: boolean;
}

const createGoal = ({
  grpId,
  goalData,
  orgId,
  location
}: {
  grpId: string;
  goalData: IGoalData;
  orgId?: string;
  location?: string;
}) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/createGoal`, goalData, {
    headers: {
      ...(orgId ? { orgId } : {}),
      ...(location ? { location } : {})
    },
    cache: false
  });
};

const createCall = (callData: any, orgId: string, location: string, currentUserId: string) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/scheduleCall?userId=${currentUserId}`,
  //   headers: {
  //     orgId: orgId,
  //     location: location
  //   },
  //   data: callData
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/scheduleCall?userId=${currentUserId}`, callData, {
    headers: {
      orgId: orgId,
      location: location
    },
    cache: false
  });
};

const getScheduleCall = async (
  user_id: string,
  userCommunicationId: string,
  orgId: string,
  location: string,
  page: number,
  pageSize: number,
  useCache?: boolean
) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getScheduleCall?userId=${user_id}&communicationId=${userCommunicationId}&page=${page}&pageSize=${pageSize}`,
  //   headers: {
  //     orgId,
  //     location
  //   }
  // });

  // Set cache options based on the useCache parameter
  const cacheOptions = useCache
    ? {
        ttl: 1000 * 60 * 5 // cache for 5 minutes
      }
    : false; // bypass cache

  return axiosCached.get(
    `${process.env.REACT_APP_API}/getScheduleCall?userId=${user_id}&communicationId=${userCommunicationId}&page=${page}&pageSize=${pageSize}`,
    {
      headers: {
        orgId,
        location
      },
      // cache: cacheOptions
      cache: { ttl: 1000 * 2 * 1 }
    }
  );
};

const cancelScheduleCall = async (
  userId: string,
  meetingId: string,
  orgId: string,
  location: string,
  callCancelReason: any
) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/cancelCall?userId=${userId}&meetingId=${meetingId}`,
  //   headers: {
  //     orgId,
  //     location
  //   },
  //   data: callCancelReason
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/cancelCall?userId=${userId}&meetingId=${meetingId}`,
    callCancelReason,
    {
      headers: {
        orgId,
        location
      },
      cache: false
    }
  );
};

const rejectScheduleCall = async (
  userId: string,
  meetingId: string,
  orgId: string,
  location: string,
  callRejectReason: any
) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/rejectCall?userId=${userId}&meetingId=${meetingId}`,
  //   headers: {
  //     orgId,
  //     location
  //   },
  //   data: callRejectReason
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/rejectCall?userId=${userId}&meetingId=${meetingId}`,
    callRejectReason,
    {
      headers: {
        orgId,
        location
      },
      cache: false
    }
  );
};

// `refresh` skips the 5 minute cache and stores the new answer, for when membership just changed.
const groupsListForUser = async (orgId: string, opts: { refresh?: boolean } = {}) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/groupsListForUser`,
  //   headers: {
  //     orgId
  //   }
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/groupsListForUser`, {
    headers: {
      orgId: orgId
    },
    cache: {
      ttl: 1000 * 60 * 5,
      override: Boolean(opts.refresh)
    }
  });
};

// const updateLastseen = (data: { id: string; name: string; role: string } | {}) => {
//
// };

const updateLastseen = (data: { id: string; name: string; role: string } | {}) => {
  const { orgId, location } = getUserDetails();
  const url = `${process.env.REACT_APP_API}/groups/userInProgram`;

  // const { orgId } = getUserDetails();

  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/groups/userInProgram`,
  //   headers: {
  //     orgId
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/groups/userInProgram`, data, {
    headers: {
      orgId
    },
    cache: false
  });
};

const checkCallParticipant = async (callMeetingId: string, currentUserId: string, orgId: string, location: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/checkCallParticipant?meetingId=${callMeetingId}&userId=${currentUserId}`,
  //   headers: {
  //     orgId,
  //     location
  //   }
  // });

  return axiosCached.get(
    `${process.env.REACT_APP_API}/checkCallParticipant?meetingId=${callMeetingId}&userId=${currentUserId}`,
    {
      headers: {
        orgId,
        location
      },
      cache: false
    }
  );
};

/**
 * Google Meet attendance check — queries the Meet conference records to see
 * which expected attendees actually joined. Triggered right after the user
 * closes the meeting tab so the FE can show a toast / redirect with status.
 * Returns 404 for non-Google-Meet meetings (Dosen/Zoom/Teams) — callers should
 * gate by `meetingType === 'Gmeet'`.
 */
const checkGoogleMeetAttendance = (meetingId: string, orgId?: string, location?: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/googleMeetAttendance/${meetingId}`, {
    headers: {
      ...(orgId ? { orgId } : {}),
      ...(location ? { location } : {})
    },
    cache: false
  });
};

const rejoinCallUpdateFlag = (userId: string, meetingId: string, orgId: string, location: string) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/updateCallRejoinStatus?meetingId=${meetingId}&userId=${userId}`,
  //   headers: {
  //     orgId: orgId,
  //     location: location
  //   }
  // });
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/updateCallRejoinStatus?meetingId=${meetingId}&userId=${userId}`,
    null,
    {
      headers: {
        orgId: orgId,
        location: location
      },
      cache: false
    }
  );
};

// For goal upload Files
const goalFilesUpload = ({
  orgId,
  grpId,
  data,
  location
}: {
  orgId: string;
  grpId: string;
  data: FormData;
  location?: string;
}) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/goalUpload`, data, {
    headers: {
      orgId: orgId,
      ...(location ? { location } : {})
    },
    cache: false
  });
};

const saveConcernWithEmail = ({ reasonOfConcern }: { reasonOfConcern: string }) => {
  const formData = new FormData();
  formData.append('reasonOfConcern', reasonOfConcern);
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/raisedConcernEmail`,
  //   data: formData
  // });
  return axiosCached.post(`${process.env.REACT_APP_API}/raisedConcernEmail`, formData, { cache: false });
};

const activateUser = ({ grpId, userId, isActive }: { grpId: string; userId: string; isActive: boolean }) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/user/${userId}/userToggle?activation=${isActive}`
  // });

  return axiosCached.post(
    `${process.env.REACT_APP_API}/group/${grpId}/user/${userId}/userToggle?activation=${isActive}`,
    null,
    { cache: false }
  );
};

const saveAIMentorQuiz = ({ answers }: any) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/AIMentorQuiz`,
  //   data: answers
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/AIMentorQuiz`, answers, {
    cache: false // Setting cache to false to disable caching
  });
};

const saveArticleDescriptionFiles = (data: any) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/articleDescriptionFiles`,
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/articleDescriptionFiles`, data, { cache: false });
};
const saveTaskDescriptionFiles = (data: any) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/taskDescriptionFiles`,
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/taskDescriptionFiles`, data, { cache: false });
};

const deleteDescriptionFile = (fileName: any, descriptionkey: 'task' | 'article', location: any) => {
  return axiosCached.delete(`${process.env.REACT_APP_API}/removeDescriptionFiles`, {
    headers: {
      location: location
    },
    data: {
      descriptionkey,
      fileName
    },
    cache: false
  });
};
const saveVotevalue = (data: any, location: any) => {
  // return axios({
  //   method: 'POST',
  //   url: `${process.env.REACT_APP_API}/addUserProfileUpvoteAndDownvote`,
  //   headers: {
  //     location: location
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/addUserProfileUpvoteAndDownvote`, data, {
    headers: {
      location: location
    },
    cache: false
  });
};

const getChatUsers = (query: string) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getAllUsersForChat?searchTerm=${query}`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getAllUsersForChat`, {
    params: {
      searchTerm: query
    },
    cache: false
  });
};

// AI Mentor API's Services

const getPrompts = () => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getPrompts`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getPrompts`, { cache: false });
};

const newConversationHashtreeFalse = (data: any) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/chat/new/from-prompt`,
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/chat/new/from-prompt`, data, {
    cache: false
  });
};

// const response = await newConversationHashtreeFalse({
//   promptID: 3,
// });

const newConversationHashtreeTrue = (promptID: any) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/prompts/${promptID}/tree`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/prompts/${promptID}/tree`, { cache: false });
};

const aiSendMessage = (data: any) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/aiSendMessage`,
  //   data
  // });

  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/aiSendMessage`,
  //   data
  // })

  return axiosCached.post(`${process.env.REACT_APP_API}/aiSendMessage`, data, {
    cache: false
  });
};
// {
//   "conversationID" : 47
// }

const getConversationPreviews = () => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/getConversationPreviews`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/getConversationPreviews`, {
    cache: false // Setting cache to false to disable caching
  });
};

const newConversationFromGeneral = (data: any) => {
  // return axios({
  //   method: 'post',
  //   url: `${process.env.REACT_APP_API}/newConversationFromGeneral`,
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/newConversationFromGeneral`, data, {
    cache: {
      ttl: 0 // Setting ttl to 0 to bypass caching
    }
  });
};

// {
//   "message" : "Give me Collages list indian"
// }

// const conversationFromTree = (data: any) => {
//   console.log('data',data,typeof(data.promptID),typeof(data.selectedOptions));

//   return axios({
//     method: 'get',
//     url: `${process.env.REACT_APP_API}/conversationFromTree`,
//     data
//   });
// };

// const conversationFromTree = (data: any) => {
//   console.log('data', data, typeof(data.promptID), typeof(data.selectedOptions));

//   // Use `params` instead of `data` for a GET request
//   return axios({
//     method: 'get',
//     url: `${process.env.REACT_APP_API}/conversationFromTree`,
//     data: JSON.stringify(data),
//   });
// };

const conversationFromTree = ({
  tokens,
  orgId,
  data
}: {
  tokens: {
    access_token: string;
    id_token: string;
  };
  orgId: string;
  data: any;
}) => {
  // return fetch(`${process.env.REACT_APP_API}/conversationFromTree`, {
  //   method: 'POST', // Use POST method
  //   body: JSON.stringify(data),
  //   headers: {
  //     Authorization: `Bearer ${tokens.access_token}`,
  //     idtoken: tokens.id_token,
  //     orgId: orgId
  //   },
  // })
  //   .then(response => response.json())
  //   .then(data => {
  //     console.log('Success:', data);
  //     return data;
  //   })
  //   .catch((error) => {
  //     console.error('Error:', error);
  //     throw error;
  //   });

  return axiosCached
    .post(`${process.env.REACT_APP_API}/conversationFromTree`, data, {
      headers: {
        Authorization: `Bearer ${tokens.access_token}`,
        idtoken: tokens.id_token,
        orgId: orgId
      },
      cache: {
        ttl: 0 // Setting ttl to 0 to bypass caching
      }
    })
    .then((response) => {
      // response.data contains the parsed response body
      // console.log('Success:', response.data);
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

// const response = await getConversationFromTree({
//   promptID: 2,
//   selectedOptions: [1, 2, 3],
// });

// Response =>
// {
//   "success": true,
//   "id": 136
// }

// we need to  dispatch(setCurrentConversationID(id));

const getConversationById = (conversatioID: any) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/chat/${conversatioID}`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/chat/${conversatioID}`, { cache: false });
};

// The session headers (authorization, idtoken) come from the request interceptor in App.tsx, as
// for every other call. Asking Auth0 for fresh tokens here made the bio the one field that failed
// to save whenever the SDK could not renew silently (an expired SDK cache, blocked third party
// cookies), and it failed without a word because the caller fires it unawaited.
const updateBio = ({ orgId, data }: { orgId: string; data: any }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/updateBio`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const createTask = (taskData: any, location: string, groupId: any, userId?: string) => {
  const urlPart = userId ? `?userId=${userId}` : ``;
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/group/${groupId}/createLevel` + urlPart,
    headers: {
      location: location
    },
    data: taskData
  });

  // return axiosCached.post(`${process.env.REACT_APP_API}/scheduleCall?userId=${currentUserId}`, callData, {
  //   headers: {
  //     orgId: orgId,
  //     location: location
  //   },
  //   cache: false
  // });
};

const editTask = (taskData: any, location: string, groupId: any, levelId: any, userId?: string) => {
  const urlPart = userId ? `?userId=${userId}` : ``;
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/updateLevel` + urlPart,
    headers: {
      location: location
    },
    data: taskData
  });
};

const addTaskToLevel = (taskData: any, location: string, groupId: any, levelId: any) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/createTask`,
    headers: {
      location: location
    },
    data: taskData
  });
};

const goalLevelDelete = (groupId: any, location: string, levelId: any, userId?: string) => {
  const urlPart = userId ? `?userId=${userId}` : ``;
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/deleteLevel` + urlPart,
    headers: {
      location: location
    }
  });
};

const getAdminProgramList = ({
  orgId,
  idtoken,
  authorization
}: {
  orgId: string;
  idtoken: string;
  authorization: string;
}) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/groups/${orgId}/admin/programs`, {
    headers: {
      idtoken,
      authorization: `Bearer ${authorization}`
    },
    cache: false
  });
};

const getUserProgramList = ({
  orgId,
  idtoken,
  authorization
}: {
  orgId: string;
  idtoken: string;
  authorization: string;
}) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/groups/${orgId}/member/programs`, {
    headers: {
      idtoken,
      authorization: `Bearer ${authorization}`
    },
    cache: false
  });
};

// ─── Learning Lifecycle / Learning Framework ────────────────────────────────
// BE commit 494d4e23 (Dosen-v2-BE). See /v3AdminPrograms, /orgs/{orgId}/pillars,
// /pillars/{id}, /programs/{id}, /group/{grpId}/launchDate,
// /members/learning-framework/{orgId}.

interface LLAuthHeaders {
  idtoken: string;
  authorization: string;
  location?: string;
  orgid?: string; // Auth0 org id — required by verifyOrganization middleware
}

const llHeaders = ({ idtoken, authorization, location, orgid }: LLAuthHeaders) => ({
  idtoken,
  authorization: `Bearer ${authorization}`,
  ...(location ? { location } : {}),
  ...(orgid ? { orgid } : {})
});

// GET /gamification/learner/summary[?grpId=] — learner gamification summary
// (streak, medals, top performers, programs due, running score). grpId is
// only needed for the course-level running score on the Lesson Complete strip.
const getLearnerGamificationSummary = ({
  grpId,
  idtoken,
  authorization,
  location
}: { grpId?: string } & LLAuthHeaders) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/gamification/learner/summary`, {
    headers: llHeaders({ idtoken, authorization, location }),
    params: grpId ? { grpId } : undefined,
    cache: false
  });
};

// GET /gamification/admin/summary — org-wide tier roll-up for the admin
// gamification bar (the five medal sections pooled across the org's
// learners, test accounts excluded). teamIds narrows the pool to learners in
// those Teams-list values (the Learning Gaps panel's Teams filter).
const getAdminGamificationSummary = ({
  idtoken,
  authorization,
  location,
  teamIds
}: { teamIds?: string[] } & LLAuthHeaders) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/gamification/admin/summary`, {
    headers: llHeaders({ idtoken, authorization, location }),
    params: teamIds && teamIds.length > 0 ? { teamIds: teamIds.join(',') } : undefined,
    cache: false
  });
};

/**
 * Four independent call sites ask for the admin program list on an admin's
 * first screen — the setup progress, the learning lifecycle, the setup guide
 * modal and the members page — and none of them goes through React Query, so
 * the same list was fetched three times in a single startup at around 4
 * seconds a call. This collapses them: concurrent callers share one request,
 * and a caller arriving just after it resolves reuses the response.
 *
 * The window is deliberately short. The list changes when a program is created
 * or deleted, and ten seconds is long enough to cover one startup without
 * outliving a change the admin makes themselves. Keyed by URL, so a platform
 * admin switching org never reads another org's list.
 */
const V3_ADMIN_PROGRAMS_REUSE_MS = 10 * 1000;
const v3AdminProgramsInFlight = new Map<string, { at: number; request: Promise<any> }>();
// Any write (a program created, deleted, moved, an invite synced…) can change the list, so it ends
// the reuse window: the next caller fetches again instead of reading the list from before the write.
axios.interceptors.response.use((response) => {
  if ((response.config?.method || 'get').toLowerCase() !== 'get') v3AdminProgramsInFlight.clear();
  return response;
});

// GET /v3/admin/programs?orgId=...  (orgId only required for platform admins)
const getV3AdminPrograms = ({
  orgId,
  idtoken,
  authorization,
  location
}: { orgId?: string } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  const url = `${process.env.REACT_APP_API}/v3/admin/programs${qs}`;

  const shared = v3AdminProgramsInFlight.get(url);
  if (shared && Date.now() - shared.at < V3_ADMIN_PROGRAMS_REUSE_MS) return shared.request;

  const request = axiosCached
    .get(url, {
      headers: llHeaders({ idtoken, authorization, location }),
      cache: false
    })
    // A failure must never be the answer the next caller reuses.
    .catch((error) => {
      v3AdminProgramsInFlight.delete(url);
      throw error;
    });

  v3AdminProgramsInFlight.set(url, { at: Date.now(), request });
  // Don't hold the response past its reuse window.
  setTimeout(() => {
    if (v3AdminProgramsInFlight.get(url)?.request === request) v3AdminProgramsInFlight.delete(url);
  }, V3_ADMIN_PROGRAMS_REUSE_MS);
  return request;
};

// PATCH /v3/admin/orgs/{orgId}/flags  — platform-admin-only per-org flags.
// Send only the flags to change. No UI calls this any more: the product
// features are GA and the two switches that remain real (`editingFrozen`,
// `courseVersioning`) are flipped from the BE scripts. Kept so the endpoint
// stays reachable from the FE.
const updateOrgFlags = ({
  orgId,
  flags,
  idtoken,
  authorization,
  location
}: {
  orgId: string;
  flags: Partial<{
    /** Relaunch editing freeze — real per-org switch. */
    editingFrozen: boolean;
    /** Course versioning — opt-in per org until it is tested end to end. */
    courseVersioning: boolean;
    /** GA product flags — still accepted by the endpoint, no longer read. */
    learningLifecycleDashboard: boolean;
    memberLearningLifecycleDashboard: boolean;
    orgLevelAdmin: boolean;
    programCreationFlowV2: boolean;
    learningGaps: boolean;
    lessonVideoBuilder: boolean;
  }>;
} & LLAuthHeaders) => {
  return axiosCached.patch(`${process.env.REACT_APP_API}/v3/admin/orgs/${orgId}/flags`, flags, {
    headers: llHeaders({ idtoken, authorization, location }),
    cache: false
  });
};

// GET /v3/admin/elliott/orgs/{orgId}/members — platform-admin-only: every org
// member with Elliott conversation counts (Live Scenarios + Charlie chats).
// orgId accepts the org Mongo _id or Auth0 id; the BE resolves the region.
const getAdminElliottConvMembers = ({
  orgId,
  idtoken,
  authorization,
  location
}: { orgId: string } & LLAuthHeaders) => {
  return axiosCached.get(
    `${process.env.REACT_APP_API}/v3/admin/elliott/orgs/${encodeURIComponent(orgId)}/members`,
    {
      headers: llHeaders({ idtoken, authorization, location }),
      cache: false
    }
  );
};

// GET /v3/admin/elliott/orgs/{orgId}/members/{userId}/conversations —
// platform-admin-only: one member's full Elliott history (Live Scenario
// transcripts + Charlie conversations with messages).
const getAdminElliottConvHistory = ({
  orgId,
  userId,
  idtoken,
  authorization,
  location
}: { orgId: string; userId: string } & LLAuthHeaders) => {
  return axiosCached.get(
    `${process.env.REACT_APP_API}/v3/admin/elliott/orgs/${encodeURIComponent(
      orgId
    )}/members/${encodeURIComponent(userId)}/conversations`,
    {
      headers: llHeaders({ idtoken, authorization, location }),
      cache: false
    }
  );
};

// GET /v3/admin/atc/programs[?orgId=] — platform-admin-only: one row per course
// creation (course name, admin email, status, Active Time on Creation) straight
// from the DB. No orgId = every program with build-time data in both regions.
const getAdminAtcPrograms = ({
  orgId,
  idtoken,
  authorization,
  location
}: { orgId?: string } & LLAuthHeaders) => {
  const query = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.get(`${process.env.REACT_APP_API}/v3/admin/atc/programs${query}`, {
    headers: llHeaders({ idtoken, authorization, location }),
    cache: false
  });
};

// ─── Learning Framework Builder (BE docs/EPIC-learning-framework-builder.md) ─
// All routes: org admins act on their JWT org; platform admins pass orgId.
const lfQuery = (orgId?: string) => (orgId ? `?orgId=${encodeURIComponent(orgId)}` : '');

// GET /v3/admin/learning-framework — the org's saved framework or { framework: null }.
const getLearningFramework = ({
  orgId,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string } & LLAuthHeaders) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/v3/admin/learning-framework${lfQuery(orgId)}`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// POST /v3/admin/learning-framework/recommend — Elliott's live recommendation
// from the questionnaire answers; the BE saves it for the org and answers
// { framework }. Long call: the BE may fetch the website (6s) and ask the model
// twice (40s each), so the wait covers that; the caller falls back to the
// built-in engine on any error, including this timeout.
const recommendLearningFramework = ({
  answers,
  orgId,
  timeoutMs,
  idtoken,
  authorization,
  location,
  orgid
}: { answers: Record<string, unknown>; orgId?: string; timeoutMs?: number } & LLAuthHeaders) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/v3/admin/learning-framework/recommend${lfQuery(orgId)}`,
    answers,
    {
      headers: llHeaders({ idtoken, authorization, location, orgid }),
      timeout: timeoutMs ?? 150000,
      cache: false
    }
  );
};

// PUT /v3/admin/learning-framework — save the framework the built-in engine
// produced (fallback) so every admin in the org sees the same one.
const saveLearningFramework = ({
  body,
  orgId,
  idtoken,
  authorization,
  location,
  orgid
}: {
  body: { answers: Record<string, unknown>; intro?: string; programs: unknown[] };
  orgId?: string;
} & LLAuthHeaders) => {
  return axiosCached.put(`${process.env.REACT_APP_API}/v3/admin/learning-framework${lfQuery(orgId)}`, body, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// DELETE /v3/admin/learning-framework — "Start over".
const deleteLearningFramework = ({
  orgId,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string } & LLAuthHeaders) => {
  return axiosCached.delete(`${process.env.REACT_APP_API}/v3/admin/learning-framework${lfQuery(orgId)}`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// POST /v3/admin/learning-framework/added — record which recommendation each
// created program came from. Answers { added }.
const markLearningFrameworkAdded = ({
  items,
  orgId,
  idtoken,
  authorization,
  location,
  orgid
}: {
  items: { recommendationId: string; groupId: string; name?: string }[];
  orgId?: string;
} & LLAuthHeaders) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/v3/admin/learning-framework/added${lfQuery(orgId)}`,
    { items },
    {
      headers: llHeaders({ idtoken, authorization, location, orgid }),
      cache: false
    }
  );
};

// ─── Learning Gaps (BE docs/EPIC-learning-gaps.md) ──────────────────────────
// GET /v3/admin/learning-gaps?orgId=  — Teams list + per-team gaps with their
// episodes. orgId only for platform admins.
const getLearningGaps = ({
  orgId,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.get(`${process.env.REACT_APP_API}/v3/admin/learning-gaps${qs}`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// PATCH /v3/admin/learning-gaps/{gapId}/episodes/{episodeId}/recommendations/{key}
// state null clears the tick. The BE closes / reopens the episode itself and
// answers { gap, closed, reopened }.
const updateLearningGapRecommendation = ({
  gapId,
  episodeId,
  key,
  state,
  orgId,
  idtoken,
  authorization,
  location,
  orgid
}: {
  gapId: string;
  episodeId: string;
  key: 'improve' | 'discuss' | 'course' | 'knowledge';
  state: 'done' | 'ignored' | null;
  orgId?: string;
} & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/v3/admin/learning-gaps/${gapId}/episodes/${episodeId}/recommendations/${key}${qs}`,
    { state },
    { headers: llHeaders({ idtoken, authorization, location, orgid }), cache: false }
  );
};

// POST /v3/admin/learning-gaps/refresh?orgId=  — run the engine now.
const refreshLearningGaps = ({
  orgId,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.post(
    `${process.env.REACT_APP_API}/v3/admin/learning-gaps/refresh${qs}`,
    {},
    { headers: llHeaders({ idtoken, authorization, location, orgid }), cache: false }
  );
};

// PATCH /v3/admin/orgs/{orgId}/teams-list  — mark which attribute list is Teams
// (null clears). Answers { memberAttributes } with the marker applied.
const updateOrgTeamsList = ({
  orgId,
  listId,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId: string; listId: string | null } & LLAuthHeaders) => {
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/v3/admin/orgs/${orgId}/teams-list`,
    { listId },
    { headers: llHeaders({ idtoken, authorization, location, orgid }), cache: false }
  );
};

// GET /v3/admin/orgs/{orgId}/team-managers — every team of the Teams list with
// its managers, plus the org admins (managers of every team implicitly).
export interface TeamManagersResponse {
  teamsList: { listId: string; listName: string } | null;
  orgAdminIds: string[];
  // pendingEmails: invited as the team's manager, not signed up yet.
  teams: Array<{ id: string; name: string; managerIds: string[]; pendingEmails: string[] }>;
}
const getTeamManagers = ({ orgId, idtoken, authorization, location, orgid }: { orgId: string } & LLAuthHeaders) =>
  axiosCached.get<TeamManagersResponse>(`${process.env.REACT_APP_API}/v3/admin/orgs/${orgId}/team-managers`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });

// PUT /v3/admin/orgs/{orgId}/team-managers/{valueId} — replace one team's
// managers (and invited managers). Managers become admins of the team's programs.
const updateTeamManagers = ({
  orgId,
  valueId,
  managerIds,
  pendingEmails,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId: string; valueId: string; managerIds: string[]; pendingEmails: string[] } & LLAuthHeaders) =>
  axiosCached.put<{ valueId: string; managerIds: string[]; pendingEmails: string[] }>(
    `${process.env.REACT_APP_API}/v3/admin/orgs/${orgId}/team-managers/${valueId}`,
    { managerIds, pendingEmails },
    { headers: llHeaders({ idtoken, authorization, location, orgid }), cache: false }
  );

// Capability Setup — a team's roles, each role's capabilities, each capability's
// four levels. `orgId` names the org for platform admins; leave it out for
// everyone else (their token carries the org).
// GET /v3/admin/capability-setup — the Teams list, the teams (with whether the
// caller may change each, and its team managers) and every role set up in them.
// Never cached, so a reload after a save reads what the save left.
const getCapabilitySetup = ({ orgId, idtoken, authorization, location, orgid }: { orgId?: string } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.get(`${process.env.REACT_APP_API}/v3/admin/capability-setup${qs}`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// POST /v3/admin/capability-setup/roles — add a role to a team.
const createCapabilityRole = ({
  orgId,
  teamId,
  name,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string; teamId: string; name: string } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.post(
    `${process.env.REACT_APP_API}/v3/admin/capability-setup/roles${qs}`,
    { teamId, name },
    { headers: llHeaders({ idtoken, authorization, location, orgid }), cache: false }
  );
};

// PUT /v3/admin/capability-setup/roles/{roleId} — change a role. `version` is
// the version the change was made from (409 if the role has changed since),
// with only the fields that changed; `capabilities` replaces the whole list.
// The answer is the role as the backend settled it (confirmations, capability
// ids, the new version), which can differ from what was sent.
export interface CapabilityRoleUpdate {
  version: number;
  name?: string;
  capabilities?: Array<{
    id?: string;
    name: string;
    criteria: Partial<Record<'weak' | 'developing' | 'capable' | 'advanced', string>>;
  }>;
  capabilitiesConfirmed?: boolean;
  levelsConfirmed?: boolean;
  launched?: boolean;
}
const updateCapabilityRole = ({
  orgId,
  roleId,
  role,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string; roleId: string; role: CapabilityRoleUpdate } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.put(`${process.env.REACT_APP_API}/v3/admin/capability-setup/roles/${roleId}${qs}`, role, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// DELETE /v3/admin/capability-setup/roles/{roleId} — 409 once its levels have been confirmed.
const deleteCapabilityRole = ({
  orgId,
  roleId,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string; roleId: string } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.delete(`${process.env.REACT_APP_API}/v3/admin/capability-setup/roles/${roleId}${qs}`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// The org admin's shared capabilities, Development and Standards: each with its
// four levels and the roles it applies to (docs/PRD-capabilities-roundup.md).
// GET /v3/admin/capability-setup/sets — both sets (anyone who can open
// Capabilities reads them: a team manager sees the ones applied to their roles).
const getCapabilitySets = ({ orgId, idtoken, authorization, location, orgid }: { orgId?: string } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.get(`${process.env.REACT_APP_API}/v3/admin/capability-setup/sets${qs}`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// PUT /v3/admin/capability-setup/sets/{kind} — change a set (org and platform
// admins only). As a role's: the version it was made from (409 if changed
// since), only the fields that changed, and `capabilities` replaces the list.
// The answer is the set as the backend settled it.
export interface CapabilitySetUpdate {
  version: number;
  capabilities?: Array<{
    id?: string;
    name: string;
    criteria: Partial<Record<'weak' | 'developing' | 'capable' | 'advanced', string>>;
    roleIds: string[];
    allRoles: boolean;
  }>;
  capabilitiesConfirmed?: boolean;
  levelsConfirmed?: boolean;
}
const updateCapabilitySet = ({
  orgId,
  kind,
  set,
  idtoken,
  authorization,
  location,
  orgid
}: { orgId?: string; kind: 'development' | 'standards'; set: CapabilitySetUpdate } & LLAuthHeaders) => {
  const qs = orgId ? `?orgId=${encodeURIComponent(orgId)}` : '';
  return axiosCached.put(`${process.env.REACT_APP_API}/v3/admin/capability-setup/sets/${kind}${qs}`, set, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

// GET /v3/admin/access — what admin access the caller has: the whole org,
// programs they administer, teams they manage.
export interface AdminAccessResponse {
  orgAdmin: boolean;
  adminProgramIds: string[];
  managedTeamIds: string[];
}
const getAdminAccess = ({ idtoken, authorization, location, orgid }: LLAuthHeaders) =>
  axiosCached.get<AdminAccessResponse>(`${process.env.REACT_APP_API}/v3/admin/access`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });

// GET /orgs/{orgId}/pillars  — auto-seeds 4 defaults on first call for the org.
const getLearningPillars = ({
  orgId,
  idtoken,
  authorization,
  location
}: { orgId: string } & LLAuthHeaders) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/orgs/${orgId}/pillars`, {
    headers: llHeaders({ idtoken, authorization, location }),
    cache: false
  });
};

// POST /orgs/{orgId}/pillars  — body: { name?, icon?, order? }
const createLearningPillar = ({
  orgId,
  body,
  idtoken,
  authorization,
  location
}: { orgId: string; body: { name?: string | null; icon?: string | null; order?: number } } & LLAuthHeaders) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/orgs/${orgId}/pillars`, body, {
    headers: llHeaders({ idtoken, authorization, location }),
    cache: false
  });
};

// PATCH /pillars/{id}  — partial update; at least one of name/icon/order required.
const updateLearningPillar = ({
  id,
  body,
  idtoken,
  authorization,
  location
}: { id: string; body: { name?: string | null; icon?: string | null; order?: number } } & LLAuthHeaders) => {
  return axiosCached.patch(`${process.env.REACT_APP_API}/pillars/${id}`, body, {
    headers: llHeaders({ idtoken, authorization, location }),
    cache: false
  });
};

// DELETE /pillars/{id}  — hard delete; programs assigned to this pillar
// have their learningPillarId cleared (cascade-to-null on the BE side).
const deleteLearningPillar = ({
  id,
  idtoken,
  authorization,
  location
}: { id: string } & LLAuthHeaders) => {
  return axiosCached.delete(`${process.env.REACT_APP_API}/pillars/${id}`, {
    headers: llHeaders({ idtoken, authorization, location }),
    cache: false
  });
};

// PATCH /programs/{id}  — partial update; at least one field required.
//   learningPillarId  → cross-pillar DnD reassignment
//   memberAttributes  → inline Audience edit
//   ownerId           → inline Owner edit
interface ProgramAudienceRule {
  listId: string;
  listName: string;
  matchType: 'any' | 'all';
  valueIds: string[];
}
interface ProgramPatchBody {
  learningPillarId?: string | null;
  /** @deprecated flat OR-matched audience — send `audienceRules` instead.
   *  Still accepted by the BE, which buckets it into per-list "any" rules. */
  memberAttributes?: string[];
  /** Per-list audience rules (any/all within a list, AND across lists). */
  audienceRules?: ProgramAudienceRule[];
  ownerId?: string | null;
  // Category dot picker — one of the 3 PROGRAM_TYPE keys.
  programType?: 'role-excellence' | 'development' | 'standards' | null;
  // Mentorship publish flips both — masterclass publishes via the
  // template endpoint which sets goalPublished indirectly.
  goalPublished?: boolean;
  settingsUpdate?: boolean;
  // Manual card sort position within a pillar column (drag-to-reorder).
  displayOrder?: number;
  // Enrollment intent — the creation-flow Members step switches it between
  // 'auto-enroll' (All learners), 'proceed' (an audience) and 'manual'.
  // 'roles': a program for roles (the build flow).
  enrollmentMode?: 'proceed' | 'auto-enroll' | 'manual' | 'roles' | null;
  // false → save the audience without enrolling anyone (Invite & Finish enrols).
  enroll?: boolean;
  // Rename: 409 when another program of the org has the name, whatever its capitals.
  name?: string;
  // The build flow: what the program is built from. Once its structure is
  // generated its roles can't change and it can't move into or out of Role
  // Excellence (409).
  roleIds?: string[];
  capabilityIds?: string[];
  format?: 'course' | 'shortCourse' | 'brief' | null;
  guided?: boolean;
  // Audience Requirements (DA-5056): the groups, whole. Sent, roleIds, audienceRules,
  // memberAttributes and enrollmentMode in the same body are ignored and derived
  // from them. 409 when they don't go together (the message names who; `overlaps`).
  audienceGroups?: ProgramAudienceGroups;
}
const patchProgram = ({
  id,
  body,
  idtoken,
  authorization,
  location,
  orgid
}: { id: string; body: ProgramPatchBody } & LLAuthHeaders) => {
  return axiosCached.patch(`${process.env.REACT_APP_API}/programs/${id}`, body, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });
};

/**
 * POST /programs/{id}/audiencePreview — read-only dry run of an audience change.
 * Returns { toAdd, toRemove } counts (plus ids) so the Program Card can warn
 * "this will remove N members" before committing. Runs the same match + diff as
 * the real save, so the number cannot disagree with what saving actually does.
 */
const previewProgramAudience = ({
  id,
  audienceRules,
  audienceGroups,
  includeMembers,
  idtoken,
  authorization,
  location,
  orgid
}: {
  id: string;
  /** Omit to evaluate the audience already STORED on the group (the BE falls
   *  back to legacy flat attributes when no rules were ever saved). */
  audienceRules?: ProgramAudienceRule[];
  /** Audience Requirements (DA-5056): PENDING groups, whoever matches any of
   *  them. Omit to evaluate the groups the program holds, when it has any. */
  audienceGroups?: ProgramAudienceGroups;
  /** true → response also carries resolved matching members
   *  ({ id, name, email, enrolled }) for the Members-page audience list. */
  includeMembers?: boolean;
} & LLAuthHeaders) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/programs/${id}/audiencePreview`,
    {
      ...(audienceRules !== undefined ? { audienceRules } : {}),
      ...(audienceGroups !== undefined ? { audienceGroups } : {}),
      ...(includeMembers !== undefined ? { includeMembers } : {})
    },
    {
      headers: llHeaders({ idtoken, authorization, location, orgid }),
      cache: false
    }
  );
};

/**
 * GET /programs/{id}/audienceRequirements (DA-5056): the program designer's
 * Audience Requirements grid, read only. A column per audience group, a row
 * per lesson, and what each group must do on each lesson; the groups as
 * stored (null before them), and `derived` when the columns are the group the
 * program would get from its roles. Read after the groups are saved, so never
 * from the cache. Anyone who may change the program may read it.
 */
const getAudienceRequirements = ({
  id,
  idtoken,
  authorization,
  location,
  orgid
}: { id: string } & LLAuthHeaders) =>
  axiosCached.get<AudienceRequirementsResponse>(`${process.env.REACT_APP_API}/programs/${id}/audienceRequirements`, {
    headers: llHeaders({ idtoken, authorization, location, orgid }),
    cache: false
  });

/**
 * POST /programs/{id}/audienceEnroll — explicitly enroll the members matching
 * the audience STORED on the group ("Invite & Finish"). The counterpart of
 * saving with enroll:false. Returns { enrolled, removed }.
 */
const enrollProgramAudience = ({
  id,
  idtoken,
  authorization,
  location,
  orgid
}: { id: string } & LLAuthHeaders) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/programs/${id}/audienceEnroll`,
    {},
    {
      headers: llHeaders({ idtoken, authorization, location, orgid }),
      cache: false
    }
  );
};

// PATCH /group/{grpId}/launchDate  — body: { launchDate: number | null } (unix seconds)
const updateGroupLaunchDate = ({
  grpId,
  launchDate,
  idtoken,
  authorization,
  location
}: { grpId: string; launchDate: number | null } & LLAuthHeaders) => {
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/group/${grpId}/launchDate`,
    { launchDate },
    {
      headers: llHeaders({ idtoken, authorization, location }),
      cache: false
    }
  );
};

// GET /members/learning-framework/{orgId}  — returns { pillars, programs }
const getMemberLearningFramework = ({
  orgId,
  idtoken,
  authorization,
  location
}: { orgId: string } & LLAuthHeaders) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/members/learning-framework/${orgId}`, {
    headers: llHeaders({ idtoken, authorization, location }),
    cache: false
  });
};

const getMemberNotifications = ({
  orgId,
  idtoken,
  authorization,
  location
}: {
  orgId: string;
  idtoken: string;
  authorization: string;
  location: string;
}) => {
  return axiosCached.get(`${collabApiBase()}/groups/${orgId}/member/notifications`, {
    headers: {
      idtoken,
      authorization: `Bearer ${authorization}`,
      location: location
    },
    cache: false
  });
};

// POST /groups/{orgId}/member/notifications/{notificationId}/read — marks one of
// the caller's stored bell items (today `program_updated`) read, so the list
// above stops returning it. → { notificationId, read: true, readAt }. Idempotent.
const markMemberNotificationRead = ({
  orgId,
  notificationId,
  idtoken,
  authorization,
  location
}: {
  orgId: string;
  notificationId: string;
  idtoken: string;
  authorization: string;
  location: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/groups/${orgId}/member/notifications/${notificationId}/read`,
    {},
    {
      headers: {
        idtoken,
        authorization: `Bearer ${authorization}`,
        location: location
      },
      cache: false
    }
  );
};

const goalTaskDelete = (groupId: any, location: string, levelId: any, taskId: any, userId?: string) => {
  const urlPart = userId ? `?userId=${userId}` : ``;
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/task/${taskId}/deleteTask` + urlPart,
    headers: {
      location: location
    }
  });
};

const goalDeleteModulesandLessons = (groupId: any, location: string, deletions: Array<{levelId: string, tasks: string[]}>) => {
  return axios({
    method: 'delete',
    url: `${process.env.REACT_APP_API}/group/${groupId}/deleteModulesAndLessons`,
    headers: {
      location: location
    },
    data: deletions
  });
};

const goalTaskBulkDelete = (groupId: any, location: string, levelId: any, taskIds: any, userId?: string) => {
  const urlPart = userId ? `?userId=${userId}` : ``;
  return axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API}/group/${groupId}/level/${levelId}/deleteTask` + urlPart,
    headers: {
      location: location
    },
    data: { tasks: taskIds }
  });
};

const updateTopics = ({ grpId, orgId, data }: { grpId: string; orgId: string; data: object }) => {
  // return axios({
  //   method: 'patch',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/updateMatchingSettings`,
  //   headers: {
  //     orgId: orgId
  //   },
  //   data
  // });

  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/topics`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getIndustriesAndTopics = ({ grpId, orgId, key }: { grpId: string; orgId: string; key: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/topicsAndIndustries?key=${key}`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const updateTopicsAndIndustry = ({
  grpId,
  orgId,
  data,
  key
}: {
  grpId: string;
  orgId: string;
  data: object;
  key: string;
}) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/topicsAndIndustries?key=${key}`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const updateLearningObjectives = ({
  grpId,
  orgId,
  data
}: {
  grpId: string;
  orgId: string;
  data: {
    // display: boolean;
    number: number;
    objectives: string[];
  };
}) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/learningObjectives`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getLearningObjectives = ({ grpId, orgId }: { grpId: string; orgId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/learningObjectives`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getUserLearningObjectives = ({ orgId }: { orgId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/UserLearningObjectives`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const UserLearningObjectives = ({ orgId }: { orgId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/UserLearningObjectives?all=true`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const adminViewObjectives = ({ orgId, grpId, userId }: { orgId: string, grpId?: string;  userId?: string}) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/UserLearningObjectives?all=true&userId=${userId}&grpId=${grpId}`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getObjectiveMentors = ({ orgId, grpId, objId }: { orgId: string; grpId: string; objId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/groups/${grpId}/objectives/${objId}/matches`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getAllObjectiveMentors = ({ orgId, grpId }: { orgId: string; grpId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/groups/${grpId}/objectives/mentor/matches`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getAllObjectiveMentees = ({ orgId, grpId }: { orgId: string; grpId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/groups/${grpId}/objectives/mentee/matches`, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const updateObjectiveMentors = ({
  orgId,
  grpId,
  objId,
  mentors
}: {
  orgId: string;
  grpId: string;
  objId: string;
  mentors: any;
}) => {
  return axios.post(`${process.env.REACT_APP_API}/groups/${grpId}/objectives/${objId}/matches`, {
    mentors
  });
};
const saveLearningObjectives = ({ learningObjectives }: { learningObjectives: any }) => {
  return axios.post(`${process.env.REACT_APP_API}/UserLearningObjectives`, {
    learningObjectives
  });
};
const saveTopicsForUser = ({ orgId, data }: { orgId: string; data: object }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/saveTopicsForUser`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const saveCompanyInfo = ({ orgId, data }: { orgId: string; data: object }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/createCompanyInfo`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const saveCompanyPosition = ({ orgId, data }: { orgId: string; data: object }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/companyPosition`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const bulkMatches = ({ orgId, location }: { orgId: string; location: string }) => {
  const data = {};
  return axiosCached.post(`${process.env.REACT_APP_API}/bulk/matches`, data, {
    headers: {
      orgId,
      location
    },
    cache: false
  });
};

const basicSettingsCommunity = ({ grpId, orgId, data }: { grpId: string; orgId: string; data: object }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/basicSettingsCommunity`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const fetchAllGroupsList = (orgId: any, groupId: any) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/${orgId}/group/${groupId}/getAllGroupsList`, {
    headers: {
      orgId
    },
    cache: false
  });
  // return axios({
  //   method: 'GET',
  //   url: `${process.env.REACT_APP_API}/${orgId}/group/${groupId}/getAllGroupsList`,
  //   headers: {
  //     location: getUserDetails().location,
  //     orgId,
  //   }
  // });
};
// const fetchAllGroupsList = (orgId: any, groupId: any) => {
//   return axios({
//     method: 'GET',
//     url: `${process.env.REACT_APP_API}/${orgId}/group/${groupId}/getAllGroupsList`,
//     headers: {
//       location: getUserDetails().location,
//       orgId,
//     }
//   });
// };

const updateIndustry = ({ grpId, orgId, data }: { grpId: string; orgId: string; data: object }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/group/${grpId}/industries`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const saveIndustriesForUser = ({ orgId, data }: { orgId: string; data: object }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/saveIndustriesForUser`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getAllIndustriesForUser = (location: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/getAllIndustriesForUser`, {
    headers: { location },
    cache: { ttl: 1000 * 60 * 2 }
  });
};

const userBasicSettings = ({ userId }: { userId: string }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/userBasicSettings/${userId}`, {
    cache: false
  });
};

/** Materialize all pending invited_users rows for this user into group membership (multi-program invites). */
const syncPendingInvites = () => {
  return axios.post(`${collabApiBase()}/user/sync-pending-invites`, {});
};

const updateGroupSettings = ({
  groupId,
  location,
  payload
}: {
  groupId: string;
  location?: string;
  payload?: Record<string, any>;
}) => {
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/group/${groupId}/groupSettings`,
    payload || {},
    {
      cache: false,
      headers: location ? { location } : {}
    }
  );
};

const sendMatchRequest = ({
  requestMessage,
  menteeId,
  mentorId,
  requestGroups,
  commId
}: {
  requestMessage: string;
  menteeId?: string;
  mentorId?: string;
  requestGroups?: any;
  commId?: string;
}) => {
  const data = { requestMessage, menteeId, mentorId, requestGrps: requestGroups, communicationId: commId };
  return axiosCached.post(`${process.env.REACT_APP_API}/requestMatch/`, data, {
    cache: false
  });
};

const rejectMatchRequest = ({
  grpId,
  requestId,
  rejectMessage
}: {
  grpId: string;
  requestId: string;
  rejectMessage: string;
}) => {
  const data = { requestId, rejectMessage };
  return axiosCached.post(`${process.env.REACT_APP_API}/grp/${grpId}/rejectMatch/`, data, {
    cache: false
  });
};

const acceptMatchRequest = ({
  grpId,
  mentorId,
  menteeId,
  requestId
}: {
  grpId: string;
  mentorId: string;
  menteeId: string;
  requestId: string;
}) => {
  const data = { mentorId, menteeId, requestId };
  return axiosCached.post(`${process.env.REACT_APP_API}/grp/${grpId}/acceptMatch/`, data, {
    cache: false
  });
};

const removeMatchRequest = ({ grpId, requestId }: { grpId: string; requestId: string }) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/grp/${grpId}/requestMatch/remove/${requestId}`,
    {},
    {
      cache: false
    }
  );
};

const resetPassword = ({ orgId, data }: { orgId: string; data: object }) => {
  return axiosCached.post(`${process.env.REACT_APP_API}/resetPassword`, data, {
    headers: {
      orgId: orgId
    },
    cache: false
  });
};

const getRecommendedArticles = ({
  grpId,
  orgId,
  location,
  userId,
  taskId,
  levelId
}: {
  grpId: string;
  orgId: string;
  location: string;
  userId: string;
  taskId: string;
  levelId: string;
}) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_API}/group/${grpId}/level/${levelId}/task/${taskId}/articles?userId=${userId}`,
    headers: {
      location,
      orgId
    }
  });
};

const getRecommendedMentors = ({
  grpId,
  orgId,
  location,
  userId,
  levelId,
  taskId
}: {
  grpId: string;
  orgId: string;
  location: string;
  userId: string;
  taskId: string;
  levelId: string;
}) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_API}/group/${grpId}/level/${levelId}/task/${taskId}/mentors?userId=${userId}`,
    headers: {
      location,
      orgId
    }
  });
};

const getCallsCount = (location: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/user/calls`, {
    headers: { location },
    cache: false
  });
};

const getCompanyList = (location: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/createCompany`, {
    headers: { location },
    cache: false
  });
};

const addCompany = ({ companyName, companyLocation }: { companyName: string; companyLocation: string }) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/createCompany`,
    data: { companyName, companyLocation }
  });
};

export interface IReviewData {
  vote: number;
  score: number;
  review?: string;
  isReviewed: boolean;
  participantUsers: string[];
}

const addReview = ({ data, meetingId }: { data: IReviewData; meetingId: string }) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/meeting/${meetingId}/review`,
    data: data
  });
};
const getReviews = ({ grpId, category }: { grpId: string; category: string }) => {
  // return axios({
  //   method: 'get',
  //   url: `${process.env.REACT_APP_API}/group/${grpId}/insights?category=${category}`
  // });

  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/insights?category=${category}`, {
    // headers: { location },
    cache: false
  });
};

const getTemplateByType = ({ programType, location }: { programType: string; location: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/getTemplateByType/${programType}`, {
    headers: { location },
    cache: false
  });
};

const getUpcomingMeeting = (location: string, orgId: string) => {
  // return axiosCached.get(`${process.env.REACT_APP_API}/meetings/getUpcomingMeeting`, {
  //   headers: { location, orgId },
  //   cache: false
  // });
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_API}/meetings/getUpcomingMeeting`,
    headers: { location, orgId }
  });
};

const addCallToCalender = ({ data, meetingId }: { data: { addCallToCalender: boolean }; meetingId: string }) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/meeting/${meetingId}/addCallToCalender`,
    data
  });
};
const getTemplateByTemplateId = ({
  templateId,
  location,
  grpId,
  orgId
}: {
  templateId: string;
  location: string;
  grpId: string;
  orgId: string;
}) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/template/${templateId}`, {
    headers: { location, orgId },
    cache: false
  });
};
const saveGroupTasks = ({
  data,
  grpId,
  location,
  orgId
}: {
  data: ITaskData;
  grpId: string;
  location: string;
  orgId: string;
}) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/group/${grpId}/goal`,
    headers: {
      location,
      orgId,
      orgid: orgId
    },
    data: data
  });
};
const updateGroupTasks = ({
  data,
  grpId,
  location,
  orgId,
  templateId
}: {
  data: any;
  grpId: string;
  location: string;
  orgId: string;
  templateId: string;
}) => {
  return axios({
    method: 'patch',
    url: `${process.env.REACT_APP_API}/group/${grpId}/template/${templateId}/goal`,
    headers: {
      location,
      orgId
    },
    data: data
  });
};
const publishTask = ({ location, grpId, orgId }: { location: string; grpId: string; orgId: string }) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API}/group/${grpId}/template/publish`,
    headers: {
      location,
      orgId,
      orgid: orgId
    },
    data: {}
  });
};

const exportUsers = ({
  location,
  grpId,
  orgId,
  plan
}: {
  location: string;
  grpId: string;
  orgId: string;
  plan: boolean;
}) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/export/users/memberData`, {
    headers: { location, orgId },
    cache: false
  });
};

const exportDevelopmentPlan = ({
  location,
  grpId,
  orgId,
  plan
}: {
  location: string;
  grpId: string;
  orgId: string;
  plan: boolean;
}) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/export/users/developmentPlan`, {
    headers: { location, orgId },
    cache: false
  });
};

const exportMatches = ({
  grpId,
  orgId,
}: {
  grpId: string;
  orgId: string;
}) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/group/${grpId}/export/matches`, {
    headers: { orgId },
    cache: false
  });
};

const exportOrganizations = (location: string) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/export/organizations`, {
    headers: { location },
    cache: false
  });
};

const getPersonalThreads = ({
  acsToken,
  orgId,
  tag,
  communicationId
}: {
  acsToken: string;
  orgId: string;
  tag: string;
  communicationId: string;
}) => {
  const requestData = {
    tag,
    communicationId
  };
  return axiosCached
    .get(`${process.env.REACT_APP_API}/threads/personal`, {
      params: {
        azureToken: acsToken,
        ...requestData
      },
      headers: {
        orgId: orgId
      },
      cache: false
    })
    .then((res) => res?.data);
};
const getGroupThreads = ({
  acsToken,
  orgId,
  tag,
  communicationId
}: {
  acsToken: string;
  orgId: string;
  tag: string;
  communicationId: string;
}) => {
  const requestData = {
    tag,
    communicationId
  };
  return axiosCached
    .get(`${process.env.REACT_APP_API}/threads/group`, {
      params: {
        azureToken: acsToken,
        ...requestData
      },
      headers: {
        orgId: orgId
      },
      cache: false
    })
    .then((res) => res?.data);
};

const upadateGettingStarted = ({ userId }: { userId: string }) => {
  return axios.patch(`${process.env.REACT_APP_API}/user/${userId}/welcome?gettingStarted=true`, {});
};

const updateLevelDate = ({ data, grpId, levelId }: { data: any; grpId: string; levelId: string }) => {
  return axios.post(`${process.env.REACT_APP_API}/group/${grpId}/level/${levelId}/editLevel?delete=false`, data);
};

const getMenteeLearningObjectives = ({ objId }: { objId: string }) => {
  return axiosCached.get(`${process.env.REACT_APP_API}/${objId}/objectives`, {});
};

const updateMenteeLearningObjectives = ({ objId, data }: { objId: string; data: any }) => {
  return axios.post(`${process.env.REACT_APP_API}/${objId}/objectives`, data, {});
};

const updateObjectiveNotes = ({ objId, data }: { objId: string; data: any }) => {
  return axios.post(`${process.env.REACT_APP_API}/objectives/${objId}/objectiveNotes`, data, {});
};

const updateMentorshipScreen = () => {
  return axios.post(`${process.env.REACT_APP_API}/mentorshipScreen?mentorshipScreen=true`, {});
};

const saveBuildState = ({ grpId, data }: { grpId: string; data: any }) => {
  return axios.post(`${process.env.REACT_APP_API}/groups/${grpId}/buildState`, data);
};

// Reads the persisted wizard buildState for a group so the creation funnel
// can re-hydrate and resume at the step the admin left off. Returns the
// parsed buildState object (or null when none was saved yet).
const getBuildState = ({ grpId }: { grpId: string }) => {
  return axios.get(`${process.env.REACT_APP_API}/groups/${grpId}/buildState`);
};

const processTextDocument = ({title, content, groupId, instruction}: {
  title: string;
  content: string;
  groupId: string;
  instruction?: string;
}) => {
  return axios.post(`${process.env.REACT_APP_API}/process-text/async`, {
    title,
    content,
    groupId,
    ...(instruction ? { instruction } : {})
  }, {
    headers: {
      groupid: groupId
    },
  });
};

const processWebsiteDocument = ({title, websiteUrl, groupId, instruction}: {
  title: string;
  websiteUrl: string;
  groupId: string;
  instruction?: string;
}) => {
  return axios.post(`${process.env.REACT_APP_API}/process-website/async`, {
    title,
    websiteUrl,
    groupId,
    ...(instruction ? { instruction } : {})
  }, {
    headers: {
      groupid: groupId
    },
  });
};

const updateDocumentInstruction = (orgDocsId: string, instruction: string) => {
  return axios.patch(`${process.env.REACT_APP_API}/orgDocs/${orgDocsId}/instruction`, {
    instruction
  });
};

const getDocumentProcessingStatus = (orgDocsId: string) => {
  return axios.get(`${process.env.REACT_APP_API}/document-processing/${orgDocsId}/status`);
};

/** Removes a document from Elliott's knowledge base (Knowledge page Delete, and Update's second step). */
const deleteOrganizationDocument = (orgDocsId: string) => {
  return axios.delete(`${process.env.REACT_APP_API}/orgDocs/${orgDocsId}`);
};


// ---------------------------------------------------------------------------
// Program Generation V2 (AIMD V2 endpoints)
// ---------------------------------------------------------------------------

const generatePreview = ({
  programGenerationId,
  generalPurpose,
  learningObjectives,
  programName
}: {
  programGenerationId: string;
  generalPurpose: string;
  learningObjectives: string[];
  programName?: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/generate-preview`,
    { generalPurpose, learningObjectives, ...(programName ? { programName } : {}) },
    { cache: false }
  );
};

const improvePreview = ({
  programGenerationId,
  generalPurpose,
  learningObjectives,
  currentPreview,
  feedback,
  programName
}: {
  programGenerationId: string;
  generalPurpose: string;
  learningObjectives: string[];
  currentPreview: string;
  feedback: string;
  programName?: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/improve-preview`,
    { generalPurpose, learningObjectives, currentPreview, feedback, ...(programName ? { programName } : {}) },
    { cache: false }
  );
};

// Canonical tone list for AI program design — replaces the FE's static
// DUMMY_TONE_OPTIONS. Response: { tones: [{ value, label, description }] }.
const getProgramTones = () => {
  return axiosCached.get(`${process.env.REACT_APP_API}/program-generation/tones`, {
    cache: false
  });
};

const improveModuleStructure = ({
  programGenerationId,
  generalPurpose,
  learningObjectives,
  moduleIndex,
  feedback,
  programPreview
}: {
  programGenerationId: string;
  generalPurpose: string;
  learningObjectives: string[];
  moduleIndex: number;
  feedback: string;
  programPreview?: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/improve-module-structure`,
    { generalPurpose, learningObjectives, moduleIndex, feedback, ...(programPreview ? { programPreview } : {}) },
    { cache: false }
  );
};

const improveProgramStructure = ({
  programGenerationId,
  generalPurpose,
  learningObjectives,
  feedback,
  programPreview
}: {
  programGenerationId: string;
  generalPurpose: string;
  learningObjectives: string[];
  feedback: string;
  programPreview?: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/improve-program-structure`,
    { generalPurpose, learningObjectives, feedback, ...(programPreview ? { programPreview } : {}) },
    { cache: false }
  );
};

const saveStructure = ({
  programGenerationId,
  modules
}: {
  programGenerationId: string;
  modules: Array<{
    title: string;
    reasoning?: string;
    learningOutcomesServed?: string[];
    ragDocumentTitles?: string[];
    // capabilityId / outcomes: the Capability build flow's lesson tags. A structure that leaves one of the
    // program's capabilities with no lesson is refused (409, with the capability's name in its message).
    lessons: Array<{ title: string; reasoning?: string; capabilityId?: string | null; outcomes?: string[] }>;
  }>;
}) => {
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/structure`,
    { modules },
    { cache: false }
  );
};

const regenerateProgram = ({
  programGenerationId,
  feedback,
  modules
}: {
  programGenerationId: string;
  feedback: string;
  modules?: { title: string; lessons: { title: string; capabilityId?: string; outcomes?: string[] }[] }[];
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/regenerate-program`,
    { feedback, modules },
    { cache: false }
  );
};

const regenerateModule = ({
  programGenerationId,
  moduleIndex,
  feedback
}: {
  programGenerationId: string;
  moduleIndex: number;
  feedback: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/regenerate-module`,
    { moduleIndex, feedback },
    { cache: false }
  );
};

const regenerateLesson = ({
  programGenerationId,
  moduleIndex,
  lessonIndex,
  feedback
}: {
  programGenerationId: string;
  moduleIndex: number;
  lessonIndex: number;
  feedback: string;
}) => {
  return axiosCached.post(
    `${process.env.REACT_APP_API}/program-generation/${programGenerationId}/regenerate-lesson`,
    { moduleIndex, lessonIndex, feedback },
    { cache: false }
  );
};

const intercomToken = () => {
  return axios.get(`${process.env.REACT_APP_API}/intercomToken`);
};

const charlieSendMessage = ({
  input,
  convId,
  location,
  grpId
}: {
  input?: string;
  convId?: string;
  location?: string;
  grpId?: string;
}) => {
  const headers: Record<string, string> = {};
  if (location) headers.location = location;
  const params: Record<string, string> = {};
  if (convId) params.convid = convId;
  // Scope the retrieval to the user's current program so Insights V3 can count
  // Copilot usage per program (backend logs req.query.grpId on each response).
  if (grpId) params.grpId = grpId;
  return axiosCached.post(
    `${process.env.REACT_APP_API}/charlie/conversations`,
    input ? { input } : {},
    { headers, params, cache: false }
  );
};

const charlieGetConversations = ({ convId, location }: { convId?: string; location?: string }) => {
  const headers: Record<string, string> = {};
  if (location) headers.location = location;
  return axiosCached.get(`${process.env.REACT_APP_API}/charlie/conversations`, {
    headers,
    params: convId ? { convid: convId } : undefined,
    cache: false
  });
};

const charlieRateMessage = ({ logId, rating, location }: { logId: string; rating: 'up' | 'down'; location?: string }) => {
  const headers: Record<string, string> = {};
  if (location) headers.location = location;
  return axiosCached.patch(
    `${process.env.REACT_APP_API}/charlie/conversations/rating`,
    { logId, rating },
    { headers, cache: false }
  );
};

const charlieResume = ({ location }: { location?: string }) => {
  const headers: Record<string, string> = {};
  if (location) headers.location = location;
  return axiosCached.get(`${process.env.REACT_APP_API}/charlie/conversations/resume`, {
    headers,
    cache: false
  });
};

/** What Elliott remembers about the learner ("What Elliott knows about me"). */
export type ElliottLearnerProfile = {
  role: string;
  strengths: string[];
  growthAreas: string[];
  goals: string[];
};

export type ElliottLearnerProfileResponse = {
  exists: boolean;
  profile: ElliottLearnerProfile;
  source: 'welcome' | 'learner' | 'backfill' | null;
  updatedAt: string | null;
};

const charlieGetProfile = async ({ location }: { location?: string }): Promise<ElliottLearnerProfileResponse> => {
  const headers: Record<string, string> = {};
  if (location) headers.location = location;
  const res = await axios.get(`${process.env.REACT_APP_API}/charlie/profile`, { headers });
  return res?.data?.data ?? res?.data;
};

const charlieUpdateProfile = async ({
  location,
  profile
}: {
  location?: string;
  profile: ElliottLearnerProfile;
}): Promise<ElliottLearnerProfileResponse> => {
  const headers: Record<string, string> = {};
  if (location) headers.location = location;
  const res = await axios.put(`${process.env.REACT_APP_API}/charlie/profile`, profile, { headers });
  return res?.data?.data ?? res?.data;
};

// Never from the GET cache: the page refetches this right after an invite, a role change or a
// removal, and a cached answer showed the list from before (the invitee missing from Invited).
const getOrgMembers = (orgId: string, programId?: string) => {
  const qs = programId ? `?programId=${encodeURIComponent(programId)}` : '';
  return axios.get(`${process.env.REACT_APP_API}/getOrgMembersProgramProgress/${orgId}${qs}`, fresh({ headers: { orgId } }));
};

// Program View (Org Members) — members of one program with per-program metrics.
const getProgramMembersOverview = (grpId: string) => {
  return axios.get(`${process.env.REACT_APP_API}/group/${grpId}/members-overview`);
};

// Org-level onboarding fields (flat list config).
const getOrgOnboardingFields = (authId: string) => {
  return axios.get(`${process.env.REACT_APP_API}/org/${authId}/onboarding-fields`);
};

const updateOrgOnboardingFields = (
  authId: string,
  onboardingFields: Array<{ key: string; required: boolean }>
) => {
  return axios.put(`${process.env.REACT_APP_API}/org/${authId}/onboarding-fields`, {
    onboardingFields
  });
};

// Org-first invite. Org-only when `programIds` is empty (allocation happens
// later); otherwise the BE records one program invite per id.
const inviteOrgMember = (
  authId: string,
  data: {
    firstName: string;
    lastName: string;
    email: string;
    role?: string[];
    programIds?: string[];
    // The team the person joins at signup and their role in it (the Program Editor's People tab).
    // The backend applies them once it reads them (docs/PRD-program-editor-be.md).
    teamId?: string;
    roleId?: string;
  },
  // Region of the target org. Platform admins invite into orgs outside their
  // own region; an explicit header wins over the interceptor's default.
  location?: string
) => {
  return axios.post(
    `${process.env.REACT_APP_API}/org/${authId}/members/invite`,
    data,
    location ? { headers: { location } } : undefined
  );
};

// Allocate / remove an existing org member to / from a program.
const allocateMemberToProgram = (
  authId: string,
  userId: string,
  data: { programId: string; role: string | string[] }
) => {
  return axios.post(
    `${process.env.REACT_APP_API}/org/${authId}/members/${userId}/programs`,
    data
  );
};

// Switch a member of a program between its learner and one of its admins.
const changeMemberProgramRole = (authId: string, userId: string, programId: string, role: 'mentee' | 'admin') => {
  return axios.patch(`${process.env.REACT_APP_API}/org/${authId}/members/${userId}/programs/${programId}`, { role });
};

const deallocateMemberFromProgram = (authId: string, userId: string, programId: string) => {
  return axios.delete(
    `${process.env.REACT_APP_API}/org/${authId}/members/${userId}/programs/${programId}`
  );
};

// ---- Program collaborators (co-design admins) + builder edit lock ----------

export interface ProgramCollaborator {
  userId: string | null;
  name: string;
  email: string;
  headshot: string;
  /** Invited before they had an account; not signed up yet. */
  pending: boolean;
  isCreator: boolean;
  isOwner: boolean;
  /** The admin viewing the list. */
  isYou: boolean;
}

/** Stage names of the shared edit lock (see programEditLock below). */
export type EditLockStage = ProgramEditLockStage;

// Both answer production's { message, data } envelope; resolved to `data`.
const getProgramCollaborators = (grpId: string) =>
  axios
    .get<{ data: { collaborators: ProgramCollaborator[]; editLock: ProgramEditLock | null; ownerId: string | null } }>(
      `${collabApiBase()}/programs/${grpId}/collaborators`
    )
    .then((res) => res.data?.data ?? { collaborators: [], editLock: null, ownerId: null });

// Existing member ({ userId }) or a new person ({ firstName, lastName, email });
// `asOwner` also makes them the Program Owner (set on signup for a new person).
const inviteProgramCollaborator = (
  grpId: string,
  data: ({ userId: string } | { firstName: string; lastName: string; email: string }) & { asOwner?: boolean }
) =>
  axios
    .post<{ data: { collaborators: ProgramCollaborator[]; ownerId: string | null } }>(
      `${collabApiBase()}/programs/${grpId}/collaborators`,
      data
    )
    .then((res) => res.data?.data ?? { collaborators: [], ownerId: null });

// Invite Org Admin → existing member: grant the Auth0 OrgAdmin role + DB role.
const promoteOrgAdmin = (authId: string, userId: string) =>
  axios.post(`${collabApiBase()}/org/${authId}/members/${userId}/org-admin`, {});

import type { SharePointConfig, SharePointConnectionStatus } from '../types/sharepoint';

const saveSharePointConnection = async (orgId: string, config: SharePointConfig): Promise<void> => {
  await axios.post(`${process.env.REACT_APP_API}/sharepoint/connection/${orgId}`, config);
};

const testSharePointConnection = async (config: SharePointConfig): Promise<{ success: boolean; error?: string }> => {
  const res = await axios.post(`${process.env.REACT_APP_API}/sharepoint/test`, config);
  return res.data;
};

const getSharePointConnection = async (orgId: string): Promise<SharePointConnectionStatus> => {
  const res = await axios.get(`${process.env.REACT_APP_API}/sharepoint/connection/${orgId}`);
  return res.data;
};

const triggerSharePointSync = async (orgId: string): Promise<{ jobId: string }> => {
  const res = await axios.post(`${process.env.REACT_APP_API}/sharepoint/sync/${orgId}`);
  return res.data;
};

const deleteSharePointConnection = async (orgId: string): Promise<void> => {
  await axios.delete(`${process.env.REACT_APP_API}/sharepoint/connection/${orgId}`);
};

import type { TeamsConnectionStatus, TeamsConfig } from '../types/teams';

const getTeamsConnection = async (orgId: string): Promise<TeamsConnectionStatus> => {
  const res = await axios.get(`${process.env.REACT_APP_API}/teams/connection/${orgId}`);
  return res.data;
};

const connectTeams = async (
  orgId: string,
  config: TeamsConfig
): Promise<TeamsConnectionStatus & { matchedUserCount?: number; totalUserCount?: number }> => {
  const res = await axios.post(`${process.env.REACT_APP_API}/teams/connection/${orgId}`, config);
  return res.data;
};

const disconnectTeams = async (orgId: string): Promise<TeamsConnectionStatus> => {
  const res = await axios.delete(`${process.env.REACT_APP_API}/teams/connection/${orgId}`);
  return res.data;
};

// ── AI Lesson Video Builder (Presenter + Explainer) ─────────────────────────
// Program-scoped lesson videos on the legacy API (v3/video/*): one editable
// VideoProject per video, rendered asynchronously (poll the render job) and
// published as the lesson attachment. program = group id, module = level id,
// lesson = task id. Body-less POSTs send `{}` so the JSON content-type always
// carries a body.
const vbBase = `${process.env.REACT_APP_API}/v3/video`;
const vbLesson = (programId: string, moduleId: string, lessonId: string) =>
  `${vbBase}/programs/${programId}/modules/${moduleId}/lessons/${lessonId}`;
const vbNoCache = { cache: false } as const;
const vbAiCall = { cache: false, timeout: 180000 } as const;
/**
 * Status reads made on a timer. Axios has no timeout of its own, so a request
 * that never answers stayed open indefinitely — which is what the aborted,
 * status-less calls to these routes in real-user monitoring look like. A poll
 * that hasn't answered in twenty seconds has already been overtaken by the
 * next one; failing it frees the connection and lets the caller count it.
 */
const vbPoll = { cache: false, timeout: 20000 } as const;

const getLessonVideoBuilderStatus = ({
  programId,
  moduleId,
  lessonId
}: {
  programId: string;
  moduleId: string;
  lessonId: string;
}) => axiosCached.get(`${vbLesson(programId, moduleId, lessonId)}/video`, vbPoll);
const getLearnerLessonVideo = ({ programId, moduleId, lessonId }: { programId: string; moduleId: string; lessonId: string }) =>
  axiosCached.get(`${vbLesson(programId, moduleId, lessonId)}/video/learner`, vbNoCache);
const deleteLessonVideo = ({ programId, moduleId, lessonId }: { programId: string; moduleId: string; lessonId: string }) =>
  axiosCached.delete(`${vbLesson(programId, moduleId, lessonId)}/video`, vbNoCache);
const createVideoProject = ({
  programId,
  moduleId,
  lessonId,
  mode,
  targetDurationSeconds
}: {
  programId: string;
  moduleId: string;
  lessonId: string;
  mode: 'presenter' | 'explainer';
  targetDurationSeconds: number;
}) => axiosCached.post(`${vbLesson(programId, moduleId, lessonId)}/video-projects`, { mode, targetDurationSeconds }, vbNoCache);
const getVideoProject = ({ projectId }: { projectId: string }) => axiosCached.get(`${vbBase}/video-projects/${projectId}`, vbNoCache);
const updateVideoProject = ({
  projectId,
  patch
}: {
  projectId: string;
  patch: {
    guidance?: string;
    targetDurationSeconds?: number;
    brandKitSnapshot?: { background: string; text: string; outline: string; fill: string };
  };
}) => axiosCached.patch(`${vbBase}/video-projects/${projectId}`, patch, vbNoCache);
const putVideoProjectSections = ({
  projectId,
  sections
}: {
  projectId: string;
  sections: Array<{ id?: string; title: string; narration: string }>;
}) => axiosCached.put(`${vbBase}/video-projects/${projectId}/sections`, { sections }, vbNoCache);
const putVideoProjectScenes = ({
  projectId,
  scenes
}: {
  projectId: string;
  scenes: Array<{ id?: string; type: string; content: unknown; narration: string; reasoning?: string | null }>;
}) => axiosCached.put(`${vbBase}/video-projects/${projectId}/scenes`, { scenes }, vbNoCache);
const draftPresenterScript = ({ projectId }: { projectId: string }) =>
  axiosCached.post(`${vbBase}/video-projects/${projectId}/presenter/draft`, {}, vbAiCall);
const improvePresenterSection = ({
  projectId,
  sectionId,
  instruction
}: {
  projectId: string;
  sectionId: string;
  instruction?: string | null;
}) =>
  axiosCached.post(
    `${vbBase}/video-projects/${projectId}/presenter/sections/${sectionId}/improve`,
    { instruction: instruction ?? null },
    vbAiCall
  );
const draftExplainerStoryboard = ({ projectId }: { projectId: string }) =>
  axiosCached.post(`${vbBase}/video-projects/${projectId}/explainer/storyboard`, {}, vbAiCall);
const improveExplainerScene = ({
  projectId,
  sceneId,
  instruction
}: {
  projectId: string;
  sceneId: string;
  instruction?: string | null;
}) =>
  axiosCached.post(
    `${vbBase}/video-projects/${projectId}/explainer/scenes/${sceneId}/improve`,
    { instruction: instruction ?? null },
    vbAiCall
  );
const changeExplainerSceneType = ({ projectId, sceneId, type }: { projectId: string; sceneId: string; type: string }) =>
  axiosCached.post(`${vbBase}/video-projects/${projectId}/explainer/scenes/${sceneId}/type`, { type }, vbNoCache);
const requestVideoPreview = ({ projectId }: { projectId: string }) =>
  axiosCached.post(`${vbBase}/video-projects/${projectId}/preview`, {}, vbNoCache);
const requestVideoPublish = ({ projectId }: { projectId: string }) =>
  axiosCached.post(`${vbBase}/video-projects/${projectId}/publish`, {}, vbNoCache);
const getVideoRenderJob = ({ renderJobId }: { renderJobId: string }) =>
  axiosCached.get(`${vbBase}/video-render-jobs/${renderJobId}`, vbPoll);
// Organization brand kit (4 colour roles) for explainer videos — the caller's org.
const getOrganizationBrandKit = () =>
  axiosCached
    .get(`${vbBase}/organization/brand-kit`, vbNoCache)
    .then(
      (r: any) =>
        (r?.data?.brandKit ?? null) as { background: string; text: string; outline: string; fill: string } | null
    );
const updateOrganizationBrandKit = ({
  brandKit
}: {
  brandKit: { background: string; text: string; outline: string; fill: string };
}) => axiosCached.put(`${vbBase}/organization/brand-kit`, { brandKit }, vbNoCache);

// ─── Course versioning (docs/API-course-versioning.md, BE branch feat/course-versioning) ───
// Everything below is behind the org flag `courseVersioning`. Any of these
// calls answering `404 { code: 'VERSIONING_OFF' }` switches the feature off
// for the session (utils/courseVersioningSession) before the error surfaces.

export type CourseVersionKind = 'autosave' | 'before_restore' | 'before_ai' | 'published';
export type ProgramEditLockStage = 'structure' | 'content' | 'manual' | 'designer';
export type ProgramEditLockAction = 'acquire' | 'heartbeat' | 'release';
export type CourseDraftSaveReason = 'throttle' | 'hidden' | 'close';
export type CoursePublishPreset = 'minor' | 'no_action' | 'review_required' | 'custom';
export type CoursePublishJobStatus = 'processing' | 'completed' | 'partial' | 'failed';
export type LessonBadge = 'new' | 'updated' | 'action';
export type PendingActionKind = 'reread' | 'quiz' | 'scenario' | 'new';

export interface ProgramEditLock {
  userId: string;
  name: string;
  stage: string;
  acquiredAt: number;
  heartbeatAt: number;
}
export interface ProgramEditLockResult {
  acquired: boolean;
  lock: ProgramEditLock | null;
  ttlSeconds: number;
}

/** `levels` is the stored template shape (modules > lessons > MCQ + elliott). */
export interface CourseDraftShape {
  levels: any[];
  baseVersion: number;
  contentHash: string;
  dirty: boolean;
  /** unix seconds, 0 when the draft was never written */
  updatedAt: number;
  updatedBy: string;
}
export interface CourseLiveState {
  version: number;
  publishedAt: number | null;
}
export interface CourseDraftResponse {
  draft: CourseDraftShape;
  live: CourseLiveState;
  lock: ProgramEditLock | null;
  /** The program's capabilities and outcomes, when its lessons carry tags (docs/PRD-capability-lesson-roleplays.md R8). */
  lessonTags?: { capabilities: Array<{ id: string; name: string }>; outcomes: string[] } | null;
}
export interface CourseDraftSaveResponse {
  contentHash: string;
  dirty: boolean;
  versionCreated: boolean;
  updatedAt: number;
}

export interface CourseVersionListItem {
  _id: string;
  kind: CourseVersionKind;
  versionNumber?: number;
  trigger: string;
  /** unix seconds */
  createdAt: number;
  createdBy: { userId: string; name: string };
  label?: string;
  contentHash: string;
}
export interface CourseVersionsResponse {
  versions: CourseVersionListItem[];
  liveVersion: number;
}
export interface CourseVersionDetail extends CourseVersionListItem {
  grpId: string;
  templateId: string;
  snapshot: { levels: any[] };
  publish?: {
    preset: CoursePublishPreset;
    decisions: CoursePublishDecisions;
    whatsNew: CourseWhatsNew | null;
    fromVersion: number;
    toVersion: number;
    jobId: string;
  };
}

// Diff object (contract section 3), matched by id.
export interface CourseDiffModuleRef {
  id: string;
  title: string;
}
export interface CourseDiffRename {
  id: string;
  from: string;
  to: string;
}
export interface CourseDiffLessonRef {
  id: string;
  moduleId: string;
  title: string;
}
export interface CourseDiffLessonMove {
  id: string;
  title: string;
  from: { moduleId: string; index: number };
  to: { moduleId: string; index: number };
}
export interface CourseDiffQuiz {
  lessonId: string;
  added: string[];
  removed: string[];
  rewritten: string[];
  answerKeyChanged: string[];
}
/** Feedback questions (`menteeQuestions`) per lesson present on both sides, matched by question id. */
export interface CourseDiffFeedback {
  lessonId: string;
  added: string[];
  removed: string[];
  rewritten: string[];
}
export type CourseDiffSectionChange = 'added' | 'changed' | 'removed' | 'enabled' | 'disabled';
export interface CourseDiffSection {
  lessonId: string;
  caseStudies?: CourseDiffSectionChange;
  simulation?: CourseDiffSectionChange;
  quiz?: 'enabled' | 'disabled';
}
export interface CourseDiff {
  modules: {
    added: CourseDiffModuleRef[];
    removed: CourseDiffModuleRef[];
    moved: Array<CourseDiffModuleRef & { from: number; to: number }>;
    renamed: CourseDiffRename[];
  };
  lessons: {
    added: CourseDiffLessonRef[];
    removed: CourseDiffLessonRef[];
    moved: CourseDiffLessonMove[];
    renamed: CourseDiffRename[];
    textChanged: Array<{ id: string; title: string }>;
  };
  quiz: CourseDiffQuiz[];
  /** Absent on BE builds that don't diff feedback questions yet. */
  feedback?: CourseDiffFeedback[];
  sections: CourseDiffSection[];
  summary: {
    lessonsAdded: number;
    lessonsRemoved: number;
    lessonsMoved: number;
    lessonsReworded: number;
    quizzesChanged: number;
    sectionsChanged: number;
    touchedRatio: number;
  };
  /** touchedRatio >= 0.5 */
  bigChange: boolean;
}

// Decisions: a key is present only when the diff has that kind of change.
export interface CoursePublishDecisions {
  newItems?: 'required_in_progress_optional_completers' | 'required_all' | 'optional_all';
  removedItems?: 'mark_complete' | 'keep_in_progress';
  textChanged?: 'keep_silent' | 'keep_badge' | 'reread';
  quizChanged?: 'keep' | 'optional_retake' | 'require';
  scenarioChanged?: 'keep' | 'optional_retake' | 'require';
  deadline?: 'program_due_date';
  notify?: 'none' | 'in_app';
}
export interface CourseWhatsNew {
  actionNeeded: string[];
  new: string[];
  updated: string[];
}
export interface CoursePublishEffect {
  key: string;
  text: string;
  learnerCounts: Record<string, number>;
}
export interface CourseLearnerCounts {
  total: number;
  inProgress: number;
  completers: number;
  notStarted: number;
}
export interface CoursePublishPreview {
  diff: CourseDiff;
  suggestedPreset: 'minor' | 'no_action' | 'review_required';
  /** One-line "Changes:" text with titles. */
  changesLine: string;
  decisionsDefault: Record<CoursePublishPreset, CoursePublishDecisions>;
  /** The preset `effects` / `counts` / `whatsNewDefault` were computed for (the request's, else `suggestedPreset`). */
  preset: CoursePublishPreset;
  /** The resolved decisions they were computed for: `preset` defaults for this diff + the request's valid overrides. */
  decisions: CoursePublishDecisions;
  /** "What will happen" lines with counts, computed for `decisions`. */
  effects: CoursePublishEffect[];
  counts: Record<string, any>;
  learnerCounts: CourseLearnerCounts;
  /** Plain What's new the publish would store for `decisions` if none is sent; computed even when `notify` is 'none'. */
  whatsNewDefault: CourseWhatsNew;
  fromVersion: number;
  toVersion: number;
}
/** The admin's current choices for a preview; `{}` (or none) previews the suggested preset. */
export interface CoursePublishPreviewInput {
  preset?: CoursePublishPreset;
  decisions?: CoursePublishDecisions;
}
export interface CoursePublishResponse {
  jobId: string;
  versionNumber: number;
  totalLearners: number;
}
export interface CoursePublishJob {
  jobId: string;
  grpId: string;
  status: CoursePublishJobStatus;
  fromVersion: number;
  toVersion: number;
  preset: CoursePublishPreset;
  decisions: CoursePublishDecisions;
  whatsNew: CourseWhatsNew | null;
  totalLearners: number;
  processedLearners: number;
  failedLearners: number;
  error?: string;
  createdAt?: string | number;
  updatedAt?: string | number;
  completedAt?: string | number;
}

export interface CourseUpdatesResponse {
  currentVersion: number;
  /** null until the learner dismissed a What's new once */
  lastSeenVersion: number | null;
  whatsNew: CourseWhatsNew | null;
  pendingActions: Array<{ taskId: string; kind: PendingActionKind; sinceVersion: number; optional: boolean }>;
  /** 'action' wins for lessons with a required pending action */
  badges: Record<string, LessonBadge>;
  /**
   * This learner's What's New (new lessons, updated lessons with the parts that
   * changed, Required / Optional). Null when there is nothing to show; absent on
   * BE builds that predate it — the FE then derives it from `badges` +
   * `pendingActions`.
   */
  learnerWhatsNew?: LearnerWhatsNew | null;
}

/** `{ data: T }` envelope of RESPONSE.successResponseWithData. */
type Enveloped<T> = { data: T };

const versioningHeaders = () => {
  const { location, orgId } = getProgramContext();
  return { location, orgId };
};
const versioningUrl = (grpId: string, path: string) => `${process.env.REACT_APP_API}/programs/${grpId}/${path}`;
// setupCache(axios) above caches the global axios: a GET answers from memory for 5 minutes. Every
// versioning GET is re-read right after a write (save, discard, publish, restore, the publish
// job's progress), so they all skip it: Version History stayed on "No versions yet" after a
// publish (docs/BUG-version-history-stale-after-publish.md). Typed as the plain config so the
// calls infer exactly as before.
const fresh = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const uncached: AxiosRequestConfig & { cache: false } = { ...config, cache: false };
  return uncached;
};

const getCourseDraft = (grpId: string) =>
  withVersioningOffGuard(
    'getCourseDraft',
    axios.get<Enveloped<CourseDraftResponse>>(versioningUrl(grpId, 'draft'), fresh({ headers: versioningHeaders() }))
  );

const saveCourseDraft = (
  grpId: string,
  data: { levels: any[]; baseVersion: number; reason?: CourseDraftSaveReason }
) =>
  withVersioningOffGuard(
    'saveCourseDraft',
    axios.put<Enveloped<CourseDraftSaveResponse>>(versioningUrl(grpId, 'draft'), data, {
      headers: versioningHeaders()
    })
  );

const discardCourseDraft = (grpId: string) =>
  withVersioningOffGuard(
    'discardCourseDraft',
    axios.delete<Enveloped<CourseDraftResponse>>(versioningUrl(grpId, 'draft'), { headers: versioningHeaders() })
  );

const getCourseDraftDiff = (grpId: string) =>
  withVersioningOffGuard(
    'getCourseDraftDiff',
    axios.get<Enveloped<CourseDiff>>(versioningUrl(grpId, 'draft/diff'), fresh({ headers: versioningHeaders() }))
  );

const listCourseVersions = (grpId: string, params: { limit?: number; before?: number } = {}) =>
  withVersioningOffGuard(
    'listCourseVersions',
    axios.get<Enveloped<CourseVersionsResponse>>(
      versioningUrl(grpId, 'versions'),
      fresh({
        headers: versioningHeaders(),
        params
      })
    )
  );

const getCourseVersion = (grpId: string, versionId: string) =>
  withVersioningOffGuard(
    'getCourseVersion',
    axios.get<Enveloped<CourseVersionDetail>>(
      versioningUrl(grpId, `versions/${versionId}`),
      fresh({
        headers: versioningHeaders()
      })
    )
  );

const restoreCourseVersion = (grpId: string, versionId: string) =>
  withVersioningOffGuard(
    'restoreCourseVersion',
    axios.post<Enveloped<{ contentHash: string; dirty: boolean }>>(
      versioningUrl(grpId, `versions/${versionId}/restore`),
      {},
      { headers: versioningHeaders() }
    )
  );

// POST publish/preview with the admin's choices: the response echoes the
// resolved `preset` / `decisions` that `effects`, `counts` and
// `whatsNewDefault` were computed for. Nothing is written.
const getPublishPreview = (grpId: string, input: CoursePublishPreviewInput = {}) =>
  withVersioningOffGuard(
    'getPublishPreview',
    axios.post<Enveloped<CoursePublishPreview>>(versioningUrl(grpId, 'publish/preview'), input, {
      headers: versioningHeaders()
    })
  );

const publishCourse = (
  grpId: string,
  data: { preset: CoursePublishPreset; decisions: CoursePublishDecisions; whatsNew?: CourseWhatsNew | null }
) =>
  withVersioningOffGuard(
    'publishCourse',
    axios.post<Enveloped<CoursePublishResponse>>(versioningUrl(grpId, 'publish'), data, {
      headers: versioningHeaders()
    })
  );

const getPublishJob = (grpId: string, jobId: string) =>
  withVersioningOffGuard(
    'getPublishJob',
    axios.get<Enveloped<CoursePublishJob>>(
      versioningUrl(grpId, `publish/${jobId}`),
      fresh({
        headers: versioningHeaders()
      })
    )
  );

// Uses fetch + keepalive so the request still goes out when it is fired from
// pagehide (tab close / reload), where an XHR would be dropped. Bodies over
// ~64 KB are refused by the browser, so callers keep this for small payloads
// (lock release) or accept the loss (last-second draft flush).
const keepaliveJsonRequest = (url: string, method: 'POST' | 'PUT' | 'PATCH', body: unknown) => {
  const tokens = localStorage.getItem('tokens') ? JSON.parse(localStorage.getItem('tokens') || '') : {};
  const { location, orgId } = versioningHeaders();
  try {
    return fetch(url, {
      method,
      keepalive: true,
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${tokens.access_token}`,
        idtoken: tokens.id_token,
        location,
        orgId
      },
      body: JSON.stringify(body)
    }).catch(() => undefined);
  } catch {
    return Promise.resolve(undefined);
  }
};
const versioningKeepaliveRequest = (grpId: string, path: string, method: 'POST' | 'PUT', body: unknown) =>
  keepaliveJsonRequest(versioningUrl(grpId, path), method, body);

/**
 * Program edit lock. `acquire` / `heartbeat` go through axios and resolve to
 * the lock result; `release` is a keepalive fetch (safe on pagehide, like the
 * collaborators branch) and resolves to null.
 */
const programEditLock = (
  grpId: string,
  data: { action: ProgramEditLockAction; stage?: ProgramEditLockStage }
): Promise<ProgramEditLockResult | null> => {
  if (data.action === 'release') {
    return versioningKeepaliveRequest(grpId, 'edit-lock', 'POST', { action: 'release' }).then(() => null);
  }
  return axios
    .post<Enveloped<ProgramEditLockResult>>(versioningUrl(grpId, 'edit-lock'), data, {
      headers: versioningHeaders()
    })
    .then((res) => res?.data?.data ?? null);
};

/** Last-second draft flush from pagehide (reason 'close'). Best effort, see versioningKeepaliveRequest. */
const saveCourseDraftKeepalive = (grpId: string, data: { levels: any[]; baseVersion: number }) =>
  versioningKeepaliveRequest(grpId, 'draft', 'PUT', { ...data, reason: 'close' });

// ─── AIMD wizard: Content step save (docs/API-course-versioning.md §2b "Content save") ───
// PATCH program-generation/{id}/content persists the per-lesson body, quiz and
// materials on the generation artifact (what Publish materialises onto the
// template). Partial: only the fields present on a lesson are written. Works
// with the versioning flag off; `versionCreated` is then always false.

export interface ProgramGenerationContentMcq {
  question: string;
  options: string[];
  /** Option index (`"2"`), option text, or the encrypted value the status endpoint serves. */
  correct_answer: string;
  explanation?: string;
  optionReasonings?: string[];
}
export interface ProgramGenerationContentMaterial {
  /** Article id; nothing is written to the articles collection. */
  _id: string;
  title: string;
  description: string;
}
export interface ProgramGenerationContentLessonPatch {
  lessonIndex: number;
  title?: string;
  content?: string;
  mcqs?: ProgramGenerationContentMcq[];
  materials?: ProgramGenerationContentMaterial[];
}
export interface ProgramGenerationContentModulePatch {
  moduleIndex: number;
  lessons: ProgramGenerationContentLessonPatch[];
}
export interface ProgramGenerationContentSaveResponse {
  /** unix ms */
  updatedAt: number;
  lessonsUpdated: number;
  versionCreated: boolean;
}

const programGenerationUrl = (generationId: string, path: string) =>
  `${process.env.REACT_APP_API}/program-generation/${generationId}/${path}`;

const saveProgramGenerationContent = (
  generationId: string,
  data: { modules: ProgramGenerationContentModulePatch[]; reason?: CourseDraftSaveReason }
) =>
  axios.patch<Enveloped<ProgramGenerationContentSaveResponse>>(programGenerationUrl(generationId, 'content'), data, {
    headers: versioningHeaders()
  });

/** Last-second content flush from pagehide (reason 'close'). Best effort, see keepaliveJsonRequest. */
const saveProgramGenerationContentKeepalive = (
  generationId: string,
  data: { modules: ProgramGenerationContentModulePatch[] }
) => keepaliveJsonRequest(programGenerationUrl(generationId, 'content'), 'PATCH', { ...data, reason: 'close' });

// ─── AIMD wizard: version history (docs §2b "Version history", org flag `courseVersioning`) ───
// Wizard versions live in course_versions with `generationId` set and
// `snapshot: { modules }`. Same list item shape as programs/{grpId}/versions
// so the Version History drawer is reused. VERSIONING_OFF switches the
// feature off for the session like the program endpoints.

export interface ProgramGenerationVersionsResponse {
  versions: CourseVersionListItem[];
  generationId: string;
  /** The generation's `publishedAt`, null until the wizard publishes. */
  publishedAt: number | null;
}
export interface ProgramGenerationVersionDetail extends CourseVersionListItem {
  grpId: string;
  generationId: string;
  /** The generation's modules (lessons with title / content / mcq / mcqs / materials / elliott), RAG chunks and bookkeeping stripped. */
  snapshot: { modules: any[] };
}
export interface ProgramGenerationVersionRestoreResponse {
  /** unix ms */
  updatedAt: number;
  beforeRestoreVersionCreated: boolean;
}

const listProgramGenerationVersions = (generationId: string, params: { limit?: number; before?: number } = {}) =>
  withVersioningOffGuard(
    'listProgramGenerationVersions',
    axios.get<Enveloped<ProgramGenerationVersionsResponse>>(
      programGenerationUrl(generationId, 'versions'),
      fresh({
        headers: versioningHeaders(),
        params
      })
    )
  );

const getProgramGenerationVersion = (generationId: string, versionId: string) =>
  withVersioningOffGuard(
    'getProgramGenerationVersion',
    axios.get<Enveloped<ProgramGenerationVersionDetail>>(
      programGenerationUrl(generationId, `versions/${versionId}`),
      fresh({ headers: versioningHeaders() })
    )
  );

/** 423 while editing is frozen, 409 { code: 'EDIT_LOCK', lock } when another admin holds the program's edit lock. */
const restoreProgramGenerationVersion = (generationId: string, versionId: string) =>
  withVersioningOffGuard(
    'restoreProgramGenerationVersion',
    axios.post<Enveloped<ProgramGenerationVersionRestoreResponse>>(
      programGenerationUrl(generationId, `versions/${versionId}/restore`),
      {},
      { headers: versioningHeaders() }
    )
  );

// Learner side: verifyOrganization reads the org from the JWT for members and
// from the `orgid` header for platform admins looking at a program.
const learnerVersioningHeaders = () => {
  const { location, orgId } = getProgramContext();
  return { location, orgId, orgid: orgId };
};

const getCourseUpdates = (grpId: string, since?: number) =>
  withVersioningOffGuard(
    'getCourseUpdates',
    axios.get<Enveloped<CourseUpdatesResponse>>(
      versioningUrl(grpId, 'updates'),
      fresh({
        headers: learnerVersioningHeaders(),
        params: since !== undefined ? { since } : undefined
      })
    )
  );

const markCourseUpdatesSeen = (grpId: string, version: number) =>
  withVersioningOffGuard(
    'markCourseUpdatesSeen',
    axios.post<Enveloped<{ lastSeenVersion: number; currentVersion: number }>>(
      versioningUrl(grpId, 'updates/seen'),
      { version },
      { headers: learnerVersioningHeaders() }
    )
  );


export const API = {
  processTextDocument,
  getPrompts,
  getConversationById,
  conversationFromTree,
  getAdminProgramList,
  getUserProgramList,
  getMemberNotifications,
  markMemberNotificationRead,
  newConversationFromGeneral,
  getConversationPreviews,
  aiSendMessage,
  newConversationHashtreeTrue,
  newConversationHashtreeFalse,
  getOrganizations,
  removeOrganization,
  getUsersByOrgId,
  addOrganization,
  updateOrganization,
  inviteMember,
  inviteOrgAdmin,
  getMemberRoles,
  getACSToken,
  getACSThreads,
  deleteACSThread,
  getACSOrgUsers,
  createACSThread,
  sendMessageToACSThread,
  getACSThreadParticipants,
  getUserMetadData,
  updateUserFtue,
  getUsersMetaByOrgId,
  getOrgName,
  inviteApi,
  getOrgId,
  readMessagesFromThreads,
  addParticipantsToExistingChannel,
  updateGroupChatName,
  editMessage,
  deleteMessage,
  removeParticipantFromThread,
  getACSChatThreads,
  readMessagesFromThreadsByPage,
  createUserProfile,
  getUserProfile,
  updateUserProfile,
  updateUserMemberAttributes,
  getEducationAndSkills,
  addEducationAndSkills,
  updateEducationAndSkills,
  getWorkHistory,
  addWorkHistory,
  updateWorkHistory,
  deleteWorkHistory,
  deleteEducation,
  deleteAllEducationAndWorkHistory,
  getTags,
  updateSocialLinks,
  updateDisability,
  getTagsList,
  updateGroupPic,
  updateHobbies,
  updateBioData,
  getGroupByOrgId,
  getTagsListnew,
  getAllTopicsForUser,
  addUserVideoUpload,
  getAllGroups,
  readMessagesFromThreadsByNextLink,
  createGroup,
  createLevel,
  deleteVideoIntro,
  createArticle,
  createOrgArticle,
  deleteGroup,
  deleteMsgCount,
  getGroupDetails,
  getAllArticle,
  getAllArticleUser,
  DeleteArticle,
  DeleteOrgArticle,
  EditOrgArticle,
  editArticle,
  getGroupUsers,
  inviteUserToAGroup,
  bulkFilesUpload,
  getGroupMemberAttributes,
  updateGroupMemberAttributes,
  getCommunityMembers,
  getAllArticleById,
  articleAction,
  removeUserFromGroup,
  addBasicSettings,
  updateGroupInfo,
  updateProgramLock,
  getAllMatches,
  updateOptionalFields,
  updateAllMatches,
  getProgramConfiguration,
  updateProgramConfiguration,
  getAllMatchesSettings,
  revokeGroupInvitation,
  getUserProfileInAGroup,
  getUserCommunityPeersList,
  updateOrganizationSettings,
  getListToAssignMatch,
  getAIMatchSuggestions,
  assignAMatch,
  assignAMatchByObjective,
  confirmAllMatches,
  confirmMatch,
  getAllMatchesSetting,
  removeMatch,
  autoMatch,
  getMatchProfile,
  defaultMatchRequest,
  getAllTemplates,
  getAllLevels,
  getMyMentors,
  getMyMentees,
  getMentorMatches,
  getMenteeProgress,
  getAllTasks,
  getTask,
  saveAnswers,
  getElliottLesson,
  evaluateElliottSimulation,
  elliottVoiceTts,
  elliottVoiceStt,
  checkElliottQuizAnswer,
  openElliottSimulationRetake,
  getElliottImproveQueue,
  getElliottAssessment,
  improveElliottSection,
  updateElliottSection,
  improveElliottSectionOnTask,
  updateElliottSectionOnTask,
  saveMentorMultiAnswers,
  createGoal,
  getScheduleCall,
  goalFilesUpload,
  groupsListForUser,
  getMenteesPeersHomePage,
  getMentorsPeersHomePage,
  getMenteeListForMentor,
  createCall,
  checkCallParticipant,
  rejoinCallUpdateFlag,
  checkGoogleMeetAttendance,
  getAllGroupsByUserId,
  getCommunityGroupsUsersListNew,
  getUserDetailsById,
  getMentorTask,
  saveMentorAnswers,
  cancelScheduleCall,
  rejectScheduleCall,
  updateLastseen,
  getMentorHelpfulTips,
  getHelpfulTips,
  saveConcernWithEmail,
  getGroupsOverview,
  getMyMentorsForTask,
  fetchMembersInsights,
  getProgramInsightsV3,
  getMentorshipInsightsV3,
  postAimdHeartbeat,
  postAimdFinalize,
  fetchChartInsights,
  fetchInsightsMetricsCount,
  activateUser,
  saveAIMentorQuiz,
  saveArticleDescriptionFiles,
  saveTaskDescriptionFiles,
  deleteDescriptionFile,
  saveVotevalue,
  getChatUsers,
  updateBio,
  createTask,
  editTask,
  addTaskToLevel,
  goalLevelDelete,
  goalTaskDelete,
  goalDeleteModulesandLessons,
  updateTopics,
  updateTopicsAndIndustry,
  getIndustriesAndTopics,
  updateLearningObjectives,
  getLearningObjectives,
  getUserLearningObjectives,
  UserLearningObjectives,
  adminViewObjectives,
  saveLearningObjectives,
  saveTopicsForUser,
  saveCompanyInfo,
  saveCompanyPosition,
  bulkMatches,
  basicSettingsCommunity,
  goalTaskBulkDelete,
  fetchAllGroupsList,
  updateIndustry,
  saveIndustriesForUser,
  getAllIndustriesForUser,
  userBasicSettings,
  syncPendingInvites,
  getMenteeInsights,
  updateGroupSettings,
  updateInsightByArticleId,
  sendMatchRequest,
  rejectMatchRequest,
  acceptMatchRequest,
  removeMatchRequest,
  resetPassword,
  getRecommendedArticles,
  getRecommendedMentors,
  getCallsCount,
  getCompanyList,
  addCompany,
  addReview,
  getReviews,
  getCommunityGroupsUsersListNewDuplicate,
  getTemplateByType,
  getUpcomingMeeting,
  addCallToCalender,
  saveGroupTasks,
  getTemplateByTemplateId,
  publishTask,
  updateGroupTasks,
  exportUsers,
  exportDevelopmentPlan,
  exportMatches,
  exportOrganizations,
  getPersonalThreads,
  getGroupThreads,
  upadateGettingStarted,
  updateLevelDate,
  getMenteeLearningObjectives,
  updateMenteeLearningObjectives,
  updateObjectiveNotes,
  getObjectiveMentors,
  getAllObjectiveMentors,
  getAllObjectiveMentees,
  updateObjectiveMentors,
  updateMentorshipScreen,
  charlieSendMessage,
  charlieGetConversations,
  charlieRateMessage,
  charlieResume,
  charlieGetProfile,
  charlieUpdateProfile,
  intercomToken,
  saveBuildState,
  getBuildState,
  generateProgramStructure,
  generateProgramContent,
  processDocument,
  processWebsiteDocument,
  updateDocumentInstruction,
  deleteOrganizationDocument,
  getDocumentProcessingStatus,
  getOrganizationDocuments,
  getProgramContent,
  generateProgramId,
  resumeProgramId,
  getAllPrograms,
  generatePreview,
  improvePreview,
  getProgramTones,
  improveModuleStructure,
  improveProgramStructure,
  saveStructure,
  regenerateProgram,
  regenerateModule,
  regenerateLesson,
  getOrgMembers,
  getProgramMembersOverview,
  getOrgOnboardingFields,
  updateOrgOnboardingFields,
  inviteOrgMember,
  allocateMemberToProgram,
  changeMemberProgramRole,
  deallocateMemberFromProgram,
  generateLessonImage,
  generateLessonVideo,
  getLessonVideoStatus,
  saveSharePointConnection,
  testSharePointConnection,
  getSharePointConnection,
  triggerSharePointSync,
  deleteSharePointConnection,
  getTeamsConnection,
  connectTeams,
  disconnectTeams,
  // Learning Lifecycle / Learning Framework
  getV3AdminPrograms,
  updateOrgFlags,
  getAdminElliottConvMembers,
  getAdminElliottConvHistory,
  getAdminAtcPrograms,
  getLearningGaps,
  updateLearningGapRecommendation,
  refreshLearningGaps,
  getLearningFramework,
  recommendLearningFramework,
  saveLearningFramework,
  deleteLearningFramework,
  markLearningFrameworkAdded,
  updateOrgTeamsList,
  getTeamManagers,
  updateTeamManagers,
  getCapabilitySetup,
  createCapabilityRole,
  updateCapabilityRole,
  deleteCapabilityRole,
  getCapabilitySets,
  updateCapabilitySet,
  getAdminAccess,
  getLearningPillars,
  createLearningPillar,
  updateLearningPillar,
  deleteLearningPillar,
  patchProgram,
  previewProgramAudience,
  getAudienceRequirements,
  enrollProgramAudience,
  generateTaskLessonVideo,
  getLessonVideoBuilderStatus,
  getLearnerLessonVideo,
  deleteLessonVideo,
  createVideoProject,
  getVideoProject,
  updateVideoProject,
  putVideoProjectSections,
  putVideoProjectScenes,
  draftPresenterScript,
  improvePresenterSection,
  draftExplainerStoryboard,
  improveExplainerScene,
  changeExplainerSceneType,
  requestVideoPreview,
  requestVideoPublish,
  getVideoRenderJob,
  getOrganizationBrandKit,
  updateOrganizationBrandKit,
  getTaskLessonVideoStatus,
  updateGroupLaunchDate,
  getMemberLearningFramework,
  getLearnerGamificationSummary,
  getAdminGamificationSummary,
  getProgramCollaborators,
  inviteProgramCollaborator,
  promoteOrgAdmin,
  getCourseDraft,
  saveCourseDraft,
  saveCourseDraftKeepalive,
  saveProgramGenerationContent,
  saveProgramGenerationContentKeepalive,
  listProgramGenerationVersions,
  getProgramGenerationVersion,
  restoreProgramGenerationVersion,
  discardCourseDraft,
  getCourseDraftDiff,
  listCourseVersions,
  getCourseVersion,
  restoreCourseVersion,
  getPublishPreview,
  publishCourse,
  getPublishJob,
  programEditLock,
  getCourseUpdates,
  markCourseUpdatesSeen
};
